(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
/**
 * isMobile.js v0.4.1
 *
 * A simple library to detect Apple phones and tablets,
 * Android phones and tablets, other mobile devices (like blackberry, mini-opera and windows phone),
 * and any kind of seven inch device, via user agent sniffing.
 *
 * @author: Kai Mallea (kmallea@gmail.com)
 *
 * @license: http://creativecommons.org/publicdomain/zero/1.0/
 */
(function (global) {

    var apple_phone         = /iPhone/i,
        apple_ipod          = /iPod/i,
        apple_tablet        = /iPad/i,
        android_phone       = /(?=.*\bAndroid\b)(?=.*\bMobile\b)/i, // Match 'Android' AND 'Mobile'
        android_tablet      = /Android/i,
        amazon_phone        = /(?=.*\bAndroid\b)(?=.*\bSD4930UR\b)/i,
        amazon_tablet       = /(?=.*\bAndroid\b)(?=.*\b(?:KFOT|KFTT|KFJWI|KFJWA|KFSOWI|KFTHWI|KFTHWA|KFAPWI|KFAPWA|KFARWI|KFASWI|KFSAWI|KFSAWA)\b)/i,
        windows_phone       = /Windows Phone/i,
        windows_tablet      = /(?=.*\bWindows\b)(?=.*\bARM\b)/i, // Match 'Windows' AND 'ARM'
        other_blackberry    = /BlackBerry/i,
        other_blackberry_10 = /BB10/i,
        other_opera         = /Opera Mini/i,
        other_chrome        = /(CriOS|Chrome)(?=.*\bMobile\b)/i,
        other_firefox       = /(?=.*\bFirefox\b)(?=.*\bMobile\b)/i, // Match 'Firefox' AND 'Mobile'
        seven_inch = new RegExp(
            '(?:' +         // Non-capturing group

            'Nexus 7' +     // Nexus 7

            '|' +           // OR

            'BNTV250' +     // B&N Nook Tablet 7 inch

            '|' +           // OR

            'Kindle Fire' + // Kindle Fire

            '|' +           // OR

            'Silk' +        // Kindle Fire, Silk Accelerated

            '|' +           // OR

            'GT-P1000' +    // Galaxy Tab 7 inch

            ')',            // End non-capturing group

            'i');           // Case-insensitive matching

    var match = function(regex, userAgent) {
        return regex.test(userAgent);
    };

    var IsMobileClass = function(userAgent) {
        var ua = userAgent || navigator.userAgent;

        // Facebook mobile app's integrated browser adds a bunch of strings that
        // match everything. Strip it out if it exists.
        var tmp = ua.split('[FBAN');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        // Twitter mobile app's integrated browser on iPad adds a "Twitter for
        // iPhone" string. Same probable happens on other tablet platforms.
        // This will confuse detection so strip it out if it exists.
        tmp = ua.split('Twitter');
        if (typeof tmp[1] !== 'undefined') {
            ua = tmp[0];
        }

        this.apple = {
            phone:  match(apple_phone, ua),
            ipod:   match(apple_ipod, ua),
            tablet: !match(apple_phone, ua) && match(apple_tablet, ua),
            device: match(apple_phone, ua) || match(apple_ipod, ua) || match(apple_tablet, ua)
        };
        this.amazon = {
            phone:  match(amazon_phone, ua),
            tablet: !match(amazon_phone, ua) && match(amazon_tablet, ua),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua)
        };
        this.android = {
            phone:  match(amazon_phone, ua) || match(android_phone, ua),
            tablet: !match(amazon_phone, ua) && !match(android_phone, ua) && (match(amazon_tablet, ua) || match(android_tablet, ua)),
            device: match(amazon_phone, ua) || match(amazon_tablet, ua) || match(android_phone, ua) || match(android_tablet, ua)
        };
        this.windows = {
            phone:  match(windows_phone, ua),
            tablet: match(windows_tablet, ua),
            device: match(windows_phone, ua) || match(windows_tablet, ua)
        };
        this.other = {
            blackberry:   match(other_blackberry, ua),
            blackberry10: match(other_blackberry_10, ua),
            opera:        match(other_opera, ua),
            firefox:      match(other_firefox, ua),
            chrome:       match(other_chrome, ua),
            device:       match(other_blackberry, ua) || match(other_blackberry_10, ua) || match(other_opera, ua) || match(other_firefox, ua) || match(other_chrome, ua)
        };
        this.seven_inch = match(seven_inch, ua);
        this.any = this.apple.device || this.android.device || this.windows.device || this.other.device || this.seven_inch;

        // excludes 'other' devices and ipods, targeting touchscreen phones
        this.phone = this.apple.phone || this.android.phone || this.windows.phone;

        // excludes 7 inch devices, classifying as phone or tablet is left to the user
        this.tablet = this.apple.tablet || this.android.tablet || this.windows.tablet;

        if (typeof window === 'undefined') {
            return this;
        }
    };

    var instantiate = function() {
        var IM = new IsMobileClass();
        IM.Class = IsMobileClass;
        return IM;
    };

    if (typeof module !== 'undefined' && module.exports && typeof window === 'undefined') {
        //node
        module.exports = IsMobileClass;
    } else if (typeof module !== 'undefined' && module.exports && typeof window !== 'undefined') {
        //browserify
        module.exports = instantiate();
    } else if (typeof define === 'function' && define.amd) {
        //AMD
        define('isMobile', [], global.isMobile = instantiate());
    } else {
        global.isMobile = instantiate();
    }

})(this);

},{}],2:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.audio
 */
var Audio = function () {
    /**
     * @param {number} id
     * @param {Howl} howl
     */
    function Audio(id, howl) {
        _classCallCheck(this, Audio);

        /**
         * @member {number}
         */
        this._id = id;

        /**
         * @member {Howl}
         */
        this._howl = howl;
    }

    _createClass(Audio, [{
        key: "destroy",
        value: function destroy() {
            this._onend && this.howl.off("end", this._onend);
            this.stop();
        }
    }, {
        key: "play",
        value: function play() {
            this.howl.play(this.id);
        }
    }, {
        key: "stop",
        value: function stop() {
            this.howl.stop(this.id);
        }
    }, {
        key: "pause",
        value: function pause() {
            this.howl.pause(this.id);
        }

        /**
         * @returns {number}
         */

    }, {
        key: "id",
        get: function get() {
            return this._id;
        }

        /**
         * @returns {Howl}
         */

    }, {
        key: "howl",
        get: function get() {
            return this._howl;
        }
    }]);

    return Audio;
}();

exports.default = Audio;

},{}],3:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Audio = require("./Audio");

var _Audio2 = _interopRequireDefault(_Audio);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.audio
 */
var AudioManager = function () {
    function AudioManager() {
        _classCallCheck(this, AudioManager);

        /**
         * @member {Object}
         * @private
         */
        this._cache = {};

        /**
         * @member {Audio}
         * @private
         */
        this._music = null;

        /**
         * @member {boolean}
         * @private
         */
        this._isMute = false;

        var hidden = void 0;
        "undefined" !== typeof document.hidden ? (hidden = "hidden", this.visibilityChange = "visibilitychange") : "undefined" !== typeof document.mozHidden ? (hidden = "mozHidden", this.visibilityChange = "mozvisibilitychange") : "undefined" !== typeof document.msHidden ? (hidden = "msHidden", this.visibilityChange = "msvisibilitychange") : "undefined" !== typeof document.webkitHidden && (hidden = "webkitHidden", this.visibilityChange = "webkitvisibilitychange");

        document.addEventListener(this.visibilityChange, function () {
            document[hidden] ? Howler.volume(0) : Howler.volume(1);
        }, false);
    }

    /**
     * @param {string} name
     * @param {string} url
     * @param {string} extension
     * @param {string} [basePath]
     */


    _createClass(AudioManager, [{
        key: "addSound",
        value: function addSound(name, url, extension) {
            var basePath = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "";

            var howl = new Howl({
                src: basePath + url,
                format: extension,
                volume: 1,
                loop: false,
                autoplay: false,
                buffer: false
            });
            howl.name = name;
            this._cache[name] = howl;
        }

        /**
         * @param {Array.<string>} sounds
         * @param {Array.<string>} extensions
         * @param {string} [basePath]
         * @param {boolean} [buffer=false]
         * @deprecated
         */

    }, {
        key: "addSounds",
        value: function addSounds(sounds, extensions, basePath, buffer) {
            basePath = basePath || "";

            for (var i = 0; i < sounds.length; ++i) {
                var url = basePath + sounds[i];
                url = url.split("/");
                var name = url[url.length - 1];

                var urls = [];
                for (var j = 0; j < extensions.length; ++j) {
                    var extension = extensions[j];
                    urls.push(url.join("/") + extension);
                }
                var howl = new Howl({
                    src: urls,
                    volume: 1,
                    loop: false,
                    autoplay: false,
                    buffer: buffer
                });
                howl.name = name;
                this._cache[name] = howl;
            }
        }

        /**
         * @param {string} name
         * @param {string} sprite
         * @param {Array.<string>} extensions
         * @param {string} [basePath]
         * @deprecated
         */

    }, {
        key: "addSoundSprite",
        value: function addSoundSprite(name, sprite, extensions, basePath) {
            basePath = basePath || "";

            var url = basePath + name;
            url = url.split("/");

            var urls = [];
            for (var i = 0; i < extensions.length; ++i) {
                var extension = extensions[i];
                urls.push(url.join("/") + extension);
            }

            var howl = new Howl({
                src: urls,
                sprite: sprite,
                volume: 1,
                loop: false,
                autoplay: false
            });
            howl.isSoundSprite = true;
            for (var _i in sprite) {
                if (sprite.hasOwnProperty(_i)) {
                    this._cache[_i] = howl;
                }
            }
        }

        /**
         * @param name
         * @param {object} params
         * @param {number} [params.volume=1]
         * @param {boolean} [params.loop=false]
         * @param {function} [params.callback]
         * @param {*} [params.scope]
         * @param {boolean} [params.destroyOnComplete=false] Destroys the audio once the callback has fired.
         */

    }, {
        key: "playSound",
        value: function playSound(name, params) {
            params = Object.assign({}, { volume: 1, loop: false, destroyOnComplete: false }, params);
            if (typeof name !== "string") {
                name = P3.utils.selectRandom(name);
            }

            var id = -1;
            var howl = this._cache[name];
            if (!howl) {
                console.warn("Could not find sound - " + name);
                return null;
            }

            id = howl.isSoundSprite ? howl.play(name) : howl.play();
            howl.volume(params.volume || 1, id);
            howl.loop(params.loop || false, id);

            var audio = new _Audio2.default(id, howl);
            if (params.callback) {
                audio._onend = function () {
                    params.callback.call(params.scope || window);
                    if (params.destroyOnComplete) {
                        audio.destroy();
                    }
                };
                howl.on("end", audio._onend);
            }
            return audio;
        }

        /**
         * @param name
         * @param {object} params
         * @param {number} [params.volume=1]
         * @param {number} [params.delay=0]
         * @param {number} [params.fadeIn=0]
         * @param {function} [params.callback]
         * @param {*} [params.scope]
         */

    }, {
        key: "playMusic",
        value: function playMusic(name, params) {
            params = Object.assign({}, { volume: 1, delay: 0, fadeIn: 0 }, params);
            if (typeof name !== "string") {
                name = P3.utils.selectRandom(name);
            }

            var id = -1;

            // skip if no change
            if (this._music && this._music.howl.name === name) {
                return this._music;
            }

            var howl = this._cache[name];
            if (!howl) {
                console.warn("Could not find music - " + name);
                return null;
            }

            id = howl.play();
            howl.volume(params.volume || 1, id);
            howl.loop(true, id);

            var audio = new _Audio2.default(id, howl);
            if (params.callback) {
                audio._onend = function () {
                    params.callback.call(params.scope);
                };
                howl.on("end", audio._onend);
            }

            if ((params.fadeIn || 0) > 0) {
                if (this._music) {
                    this.fadeOut(this._music, params.fadeIn, function (audio) {
                        audio.destroy();
                    }, this);
                }
                this.fadeIn(audio, params.fadeIn);
            } else if (this._music) {
                this._music.destroy();
            }

            this._music = audio;
            return audio;
        }
    }, {
        key: "stopMusic",
        value: function stopMusic() {
            if (!this._music) return;
            this._music.destroy();
            this._music = null;
        }

        /**
         * @param {boolean} value
         */

    }, {
        key: "mute",
        value: function mute(value) {
            this._isMute = value;
            if (this._isMute) {
                Howler.mute(true);
            } else {
                Howler.mute(false);
            }
        }

        /**
         * @param {Audio} audio
         * @param {number} [duration=1]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "fadeIn",
        value: function fadeIn(audio) {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var callback = arguments[2];
            var scope = arguments[3];

            var volume = audio.howl.volume(audio.id);
            audio.howl.volume(0, audio.id);
            audio.__volume = 0;

            TweenMax.killTweensOf(audio);
            TweenMax.to(audio, duration, {
                __volume: volume,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    audio.howl.volume(audio.__volume, audio.id);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [audio],
                onCompleteScope: scope
            });
        }

        /**
         * @param {Audio} audio
         * @param {number} [duration=1]
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "fadeOut",
        value: function fadeOut(audio) {
            var duration = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
            var callback = arguments[2];
            var scope = arguments[3];

            audio.__volume = audio.howl.volume(audio.id);

            TweenMax.killTweensOf(audio);
            TweenMax.to(audio, duration, {
                __volume: 0,
                ease: Power1.easeInOut,
                onUpdate: function onUpdate() {
                    audio.howl.volume(audio.__volume, audio.id);
                },
                onUpdateScope: this,
                onComplete: callback,
                onCompleteParams: [audio],
                onCompleteScope: scope
            });
        }

        /**
         * @returns {Audio}
         */

    }, {
        key: "music",
        get: function get() {
            return this._music;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isMute",
        get: function get() {
            return this._isMute;
        }
    }]);

    return AudioManager;
}();

exports.default = AudioManager;

},{"./Audio":2}],4:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Audio = require("./Audio");

Object.defineProperty(exports, "Audio", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Audio).default;
  }
});

var _AudioManager = require("./AudioManager");

Object.defineProperty(exports, "AudioManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AudioManager).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./Audio":2,"./AudioManager":3}],5:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf p3.camera
 */
var Camera = function () {
    /**
     * @param {PIXI.Point} [view]
     * @param {boolean} [snapToPixel]
     */
    function Camera(view) {
        var snapToPixel = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        _classCallCheck(this, Camera);

        /**
         * @member {Object}
         * @member {signals.Signal} signals.trackStart
         * @member {signals.Signal} signals.trackStop
         */
        this.signals = {
            trackStart: new signals.Signal(),
            trackStop: new signals.Signal()
        };

        /**
         * @member {PIXI.Point}
         */
        this.view = view || new PIXI.Point();

        /**
         * @member {PIXI.Rectangle}
         */
        this.bounds = new PIXI.Rectangle(-(Number.MAX_SAFE_INTEGER * 0.5), -(Number.MAX_SAFE_INTEGER * 0.5), Number.MAX_SAFE_INTEGER, Number.MAX_SAFE_INTEGER);

        /**
         * @member {PIXI.Point}
         */
        this.offset = new PIXI.Point();

        /**
         * @member {boolean}
         */
        this.snapToPixel = snapToPixel;

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._position = new PIXI.Point();

        /**
         * @member {*}
         * @private
         */
        this._target = null;

        /**
         * @member {Array.<CameraLayer>}
         * @private
         */
        this._layers = [];

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._smoothness = new PIXI.Point(0, 0);

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._parallax = new PIXI.Point(1, 1);

        /**
         * @member {boolean}
         * @private
         */
        this._tracking = false;
    }

    /**
     */


    _createClass(Camera, [{
        key: "destroy",
        value: function destroy() {
            this.signals.trackStart.dispose();
            this.signals.trackStop.dispose();

            this.removeAllLayers();
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            var pos = this._target ? new PIXI.Point(this._target.x + this.offset.x, this._target.y + this.offset.y) : new PIXI.Point();

            this._clampToBounds(pos);

            if (this._shakeTime > 0) {
                pos.x += this._shakeStrength * P3.math.randomInt(-1, 1) * (this._shakeTime / this._shakeDuration);
                pos.y += this._shakeStrength * P3.math.randomInt(-1, 1) * (this._shakeTime / this._shakeDuration);
                this._shakeTime = Math.max(0, this._shakeTime - dt);
            }

            var to = new P3.Vector2(pos.x - this._position.x * this._parallax.x, pos.y - this._position.y * this._parallax.y);

            var sx = P3.math.clamp(60 * (1 - this._smoothness.x) * dt, 0.01, 1);
            var sy = P3.math.clamp(60 * (1 - this._smoothness.y) * dt, 0.01, 1);

            this._position.x = P3.math.lerp(this._position.x * this._parallax.x, pos.x, sx);
            this._position.y = P3.math.lerp(this._position.y * this._parallax.y, pos.y, sy);

            if (this.snapToPixel) {
                this._position.x = Math.round(this._position.x);
                this._position.y = Math.round(this._position.y);
            }

            if (to.lengthSq < 0.1 && !this._tracking) {
                this._tracking = true;
                this.signals.trackStop.dispatch(this);
            } else if (to.lengthSq > 0.1 && this._tracking) {
                this._tracking = false;
                this.signals.trackStart.dispatch(this);
            }
            this.updateLayers();
        }

        /**
         */

    }, {
        key: "updateLayers",
        value: function updateLayers() {
            for (var i = 0; i < this._layers.length; ++i) {
                var layer = this._layers[i];
                layer.view.x = this._position.x * -layer.parallax.x + this.view.x - this.view.x * (1 - layer.parallax.x);
                layer.view.y = this._position.y * -layer.parallax.y + this.view.y - this.view.y * (1 - layer.parallax.y);
            }
        }

        /**
         * @param {...CameraLayer} layer - The layer(s) to add to the camera.
         * @returns {CameraLayer} The first layer that was added.
         */

    }, {
        key: "addLayer",
        value: function addLayer(layer) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = 0; i < len; ++i) {
                    this._layers.push(arguments[i]);
                }
            } else {
                this._layers.push(layer);
            }

            this.updateLayers();
            return layer;
        }

        /**
         * @param {...CameraLayer} layer - The layer(s) to remove from the camera.
         * @returns {CameraLayer} The first layer that was added.
         */

    }, {
        key: "removeLayer",
        value: function removeLayer(layer) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = len - 1; i >= 0; --i) {
                    this.removeLayer(arguments[i]);
                }
            } else {
                var _i = this._layers.indexOf(layer);
                if (_i !== -1) {
                    this._layers.splice(_i, 1);
                } else {
                    throw new Error("Layer does not exit!");
                }
            }
            return layer;
        }

        /**
         */

    }, {
        key: "removeAllLayers",
        value: function removeAllLayers() {
            this._layers = [];
        }

        /**
         * @param {*} target
         * @param {boolean} [reset=false]
         */

    }, {
        key: "setTarget",
        value: function setTarget(target) {
            var reset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            this._target = target;

            var layer = this.findLayer(this._target, true);
            this._parallax.x = layer ? layer.parallax.x : 1;
            this._parallax.y = layer ? layer.parallax.y : 1;

            if (reset) {
                var pos = this._target ? new PIXI.Point(this._target.x + this.offset.x, this._target.y + this.offset.y) : this._position.clone();

                this._clampToBounds(pos);
                this._position.x = pos.x;
                this._position.y = pos.y;
                this.updateLayers();
            }
        }

        /**
         * @param {number} duration
         * @param {number} strength
         */

    }, {
        key: "shake",
        value: function shake(duration, strength) {
            this._shakeTime = this._shakeDuration = duration;
            this._shakeStrength = strength;
        }

        /**
         * @param {PIXI.DisplayObject} displayObject
         * @param {boolean} [recursive=false]
         */

    }, {
        key: "findLayer",
        value: function findLayer(displayObject) {
            var recursive = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

            var result = null;
            for (var i = 0; i < this._layers.length; ++i) {
                var layer = this._layers[i];
                if (layer.view === displayObject || searchChildren.call(this, layer.view, recursive)) {
                    result = layer;
                }
            }
            function searchChildren(obj, recursive) {
                for (var _i2 = 0; _i2 < obj.children.length; ++_i2) {
                    var child = obj.children[_i2];
                    if (child === displayObject) {
                        return true;
                    } else if (recursive) {
                        searchChildren.call(this, child, recursive);
                    }
                }
                return false;
            }
            return result;
        }

        /**
         * @param position
         * @returns {PIXI.Point}
         * @private
         */

    }, {
        key: "_clampToBounds",
        value: function _clampToBounds(position) {
            if (position.x < this.bounds.x) {
                position.x = this.bounds.x;
            } else if (position.x > this.bounds.width) {
                position.x = this.bounds.width;
            }
            if (position.y < this.bounds.y) {
                position.y = this.bounds.y;
            } else if (position.y > this.bounds.height) {
                position.y = this.bounds.height;
            }
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "position",
        get: function get() {
            return this._position;
        }

        /**
         * @returns {*}
         */

    }, {
        key: "target",
        get: function get() {
            return this._target;
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "smoothness",
        get: function get() {
            return this._smoothness;
        }

        /**
         * @param {PIXI.Point} value
         */
        ,
        set: function set(value) {
            this._smoothness = value;
        }

        /**
         * @returns {Array.<CameraLayer>}
         */

    }, {
        key: "layers",
        get: function get() {
            return this._layers.slice(0);
        }
    }]);

    return Camera;
}();

exports.default = Camera;

},{}],6:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf p3.camera
 */
var CameraLayer = function () {
  /**
   * @param {PIXI.Container} view
   * @param {PIXI.Point} [parallax]
   */
  function CameraLayer(view, parallax) {
    _classCallCheck(this, CameraLayer);

    /**
     * @type {PIXI.Container}
     * @private
     */
    this._view = view;

    /**
     * @type {PIXI.Point}
     * @private
     */
    this._parallax = parallax || new PIXI.Point();
  }

  /**
   * @returns {PIXI.Container}
   */


  _createClass(CameraLayer, [{
    key: "view",
    get: function get() {
      return this._view;
    }

    /**
     * @returns {PIXI.Point}
     */

  }, {
    key: "parallax",
    get: function get() {
      return this._parallax;
    }
  }]);

  return CameraLayer;
}();

exports.default = CameraLayer;

},{}],7:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Camera = require("./Camera");

Object.defineProperty(exports, "Camera", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Camera).default;
  }
});

var _CameraLayer = require("./CameraLayer");

Object.defineProperty(exports, "CameraLayer", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_CameraLayer).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./Camera":5,"./CameraLayer":6}],8:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AudioManager = require("../audio/AudioManager");

var _AudioManager2 = _interopRequireDefault(_AudioManager);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var URL = window.URL || window.webkitURL;

/**
 * @class
 * @memberOf P3
 */

var AssetManager = function () {
    /**
     * @param {Array.<string>} [soundExtensions]
     */
    function AssetManager(soundExtensions) {
        _classCallCheck(this, AssetManager);

        /**
         * @member {object}
         * @member {signals.Signal} progress
         * @member {signals.Signal} complete
         * @member {signals.Signal} error
         * @member {signals.Signal} audioFile
         */
        this.signals = {
            progress: new signals.Signal(),
            complete: new signals.Signal(),
            error: new signals.Signal(),
            audioFile: new signals.Signal()
        };

        /**
         * @type {PIXI.loaders.Loader}
         * @private
         */
        this._loader = new PIXI.loaders.Loader();
        this._loader.on("progress", this._onLoaderProgress, this);
        this._loader.on("complete", this._onLoaderComplete, this);
        this._loader.on("error", this._onLoaderError, this);

        /**
         * @type {Array}
         * @private
         */
        this._manifest = [];

        /**
         * @type {Object}
         * @private
         */
        this._resources = {};

        var graphics = new PIXI.Graphics();
        graphics.beginFill(0x0, 0.5);
        graphics.drawRect(0, 0, 100, 100);
        graphics.endFill();
        graphics.lineStyle(2, 0xFF0000, 1);
        graphics.moveTo(0, 0);
        graphics.lineTo(100, 100);
        graphics.moveTo(100, 0);
        graphics.lineTo(0, 100);

        try {
            this._fallbackTexture = graphics.generateTexture();
        } catch (e) {
            this._fallbackTexture = PIXI.Texture.EMPTY;
        }

        // set the file extension for audio files
        soundExtensions = soundExtensions || ["ogg", "m4a", "mp3"];
        for (var i = soundExtensions.length - 1; i >= 0; --i) {
            var ext = soundExtensions[i];
            if (Howler.codecs(ext)) {
                P3.AssetManager.AUDIO_FILE_EXTENSION = "." + ext;
            }
        }

        // audio files are treated as xhr blobs
        PIXI.loaders.Resource.setExtensionLoadType("ogg", PIXI.loaders.Resource.LOAD_TYPE.XHR);
        PIXI.loaders.Resource.setExtensionXhrType("ogg", PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB);
        PIXI.loaders.Resource.setExtensionLoadType("m4a", PIXI.loaders.Resource.LOAD_TYPE.XHR);
        PIXI.loaders.Resource.setExtensionXhrType("m4a", PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB);
        PIXI.loaders.Resource.setExtensionLoadType("mp3", PIXI.loaders.Resource.LOAD_TYPE.XHR);
        PIXI.loaders.Resource.setExtensionXhrType("mp3", PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB);
    }

    /**
     * @param {Array} files
     * @param {string} [path]
     * @returns {Array}
     */


    _createClass(AssetManager, [{
        key: "addFiles",
        value: function addFiles(files) {
            var path = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

            if (path && path.length > 0) {
                for (var i = 0; i < files.length; ++i) {
                    var url = files[i].url;
                    files[i].url = path + url;
                }
            }
            this._manifest = this._manifest.concat(files);
            return this._manifest;
        }

        /**
         */

    }, {
        key: "load",
        value: function load() {
            if (!this._manifest.length) return;

            this._loader.add(this._manifest);
            this._loader.load();
            return this._manifest;
        }

        /**
         * @param {string} name
         * @param {string} [extension]
         */

    }, {
        key: "unloadTexture",
        value: function unloadTexture(name, extension) {
            extension = "." + (extension || "png");

            var resource = this._resources[name];
            name = resource.url;
            name = name.replace(/\.[^/.]+$/, "");
            var texture = PIXI.utils.TextureCache[name + extension];
            texture.destroy(true);
        }

        /**
         * @param {string} name
         * @param {string} [extension]
         */

    }, {
        key: "texture",
        value: function texture(name, extension) {
            extension = "." + (extension || "png");

            var texture = void 0;
            try {
                texture = PIXI.Texture.fromFrame(name + extension);
            } catch (error) {
                if (this._resources[name]) {
                    texture = this._resources[name].texture;
                } else {
                    console.warn("texture not found :", name);
                    texture = this._fallbackTexture;
                }
            }
            P3.settings.WARN_TEXTURE_DIVISIBLE_BY_2 && (texture.width % 2 !== 0 || texture.height % 2 !== 0) && console.warn("texture dimensions not divisible by 2 :", name + extension, "(" + texture.width + "x" + texture.height + ")");
            P3.settings.WARN_TEXTURE_DIVISIBLE_BY_4 && (texture.width % 4 !== 0 || texture.height % 4 !== 0) && console.warn("texture dimensions not divisible by 4 :", name + extension, "(" + texture.width + "x" + texture.height + ")");
            return texture;
        }

        /**
         * @param {string} name
         * @returns {Object}
         */

    }, {
        key: "json",
        value: function json(name) {
            var data = P3.utils.copyObject(this._resources[name].data);
            if (!data) {
                throw new Error("json not found: " + name);
            }
            return data;
        }

        /**
         * @param {string} name
         * @returns {Object}
         */

    }, {
        key: "spineData",
        value: function spineData(name) {
            var resource = this._resources[name];
            if (!resource || resource && !resource.spineData) {
                throw new Error("spine data not found: " + name);
            }
            return resource.spineData;
        }

        /**
         * @param {PIXI.loaders.Loader} loader
         * @param {*} resource
         * @private
         */

    }, {
        key: "_onLoaderProgress",
        value: function _onLoaderProgress(loader, resource) {
            // process audio files
            if (resource.xhr && resource.xhrType === PIXI.loaders.Resource.XHR_RESPONSE_TYPE.BLOB) {
                if (["ogg", "m4a", "mp3"].indexOf(resource.extension) !== -1) {
                    try {
                        var src = URL.createObjectURL(resource.data);
                        this.signals.audioFile.dispatch(resource.name, src, resource.extension);
                    } catch (error) {
                        console.warn("Error loading sound - ", resource.name);
                    }
                }
            }
            this.signals.progress.dispatch(loader, resource, loader.progress);
        }

        /**
         * @param {PIXI.loaders.Loader} loader
         * @param {Array.<*>} resources
         * @private
         */

    }, {
        key: "_onLoaderComplete",
        value: function _onLoaderComplete(loader, resources) {
            for (var i in resources) {
                if (resources.hasOwnProperty(i)) {
                    this._resources[i] = resources[i];
                }
            }
            this._manifest.length = 0;
            this._loader.reset();

            this.signals.complete.dispatch(loader, resources);
        }

        /**
         * @param {string} error
         * @param {PIXI.loaders.Loader} loader
         * @param {Array<*>} resource
         * @private
         */

    }, {
        key: "_onLoaderError",
        value: function _onLoaderError(error, loader, resource) {
            this.signals.error.dispatch(error, loader, resource);
        }

        /**
         * @returns {object}
         */

    }, {
        key: "manifest",
        get: function get() {
            return this._manifest.slice();
        }
    }]);

    return AssetManager;
}();

/**
 * @type {string}
 */


exports.default = AssetManager;
AssetManager.AUDIO_FILE_EXTENSION = ".ogg";

},{"../audio/AudioManager":3}],9:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _ButtonStates = require("./ButtonStates");

var _ButtonStates2 = _interopRequireDefault(_ButtonStates);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var Button = function (_PIXI$Container) {
    _inherits(Button, _PIXI$Container);

    /**
     * @param {ButtonStates} states
     */
    function Button(states) {
        _classCallCheck(this, Button);

        /**
         * @member {Object}
         * @member {signals.Signal} down
         * @member {signals.Signal} up
         * @member {signals.Signal} over
         * @member {signals.Signal} out
         * @member {signals.Signal} click
         * @member {signals.Signal} animate
         */
        var _this = _possibleConstructorReturn(this, (Button.__proto__ || Object.getPrototypeOf(Button)).call(this));

        _this.signals = {
            down: new signals.Signal(),
            up: new signals.Signal(),
            over: new signals.Signal(),
            out: new signals.Signal(),
            click: new signals.Signal(),
            animate: new signals.Signal(),
            focus: new signals.Signal(),
            unfocus: new signals.Signal()
        };

        /**
         * @member {boolean}
         */
        _this.animate = true;

        /**
         * @member {boolean}
         */
        _this.animateIcon = true;

        /**
         * @member {PIXI.Point}
         */
        _this.animateOverScale = new PIXI.Point(1.1, 1.1);

        /**
         * @member {PIXI.Point}
         */
        _this.animateDownScale = new PIXI.Point(0.9, 0.9);

        /**
         * @member {string}
         */
        _this.upSoundName = null;

        /**
         * @member {string}
         */
        _this.overSoundName = null;

        /**
         * @member {string}
         */
        _this.downSoundName = null;

        /**
         * @member {string}
         */
        _this.clickSoundName = null;

        /**
         * @member {ButtonStates}
         * @protected
         */
        _this._states = states;

        /**
         * @member {PIXI.Container}
         * @private
         */
        _this._animation = new PIXI.Container();
        _this.addChild(_this._animation);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._background = new PIXI.Sprite(_this._states.normal);
        _this._background.anchor = new PIXI.Point(0.5, 0.5);
        _this._animation.addChild(_this._background);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._icon = new PIXI.Sprite(_this._states.icon || PIXI.Texture.EMPTY);
        _this._icon.anchor = new PIXI.Point(0.5, 0.5);
        _this._icon.interactive = false;
        _this._animation.addChild(_this._icon);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._focus = new PIXI.Sprite(_this._states.focus || PIXI.Texture.EMPTY);
        _this._focus.anchor = new PIXI.Point(0.5, 0.5);
        _this._focus.visible = false;
        _this._focus.interactive = false;
        _this._animation.addChild(_this._focus);

        /**
         * @member {PIXI.Sprite}
         * @protected
         */
        _this._shortcutIcon = new PIXI.Sprite(PIXI.Texture.EMPTY);
        _this._shortcutIcon.anchor = new PIXI.Point(0.5, 0.5);
        _this._shortcutIcon.visible = !_ismobilejs2.default.any;
        _this._shortcutIcon.interactive = false;
        _this._background.addChild(_this._shortcutIcon);

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentNormalTexture = _this._states.normal;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentOverTexture = _this._states.over;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentDownTexture = _this._states.down;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconTexture = _this._states.icon;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconOverTexture = _this._states.iconOver;

        /**
         * @member {PIXI.Texture}
         * @protected
         */
        _this._currentIconDownTexture = _this._states.iconDown;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenOver = null;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenOut = null;

        /**
         * @member {TweenMax}
         * @protected
         */
        _this._tweenDown = null;

        /**
         * @member {boolean}
         * @protected
         */
        _this._enabled = true;

        /**
         * @member {boolean}
         * @private
         */
        _this._focused = false;

        _this.interactive = true;
        _this.buttonMode = true;

        _this.on("mousedown", _this.onMouseDown, _this);
        _this.on("mouseup", _this.onMouseUp, _this);
        _this.on("mouseupoutside", _this.onMouseUpOutside, _this);
        _this.on("click", _this.onMouseClick, _this);
        _this.on("mouseover", _this.onMouseOver, _this);
        _this.on("mouseout", _this.onMouseOut, _this);
        _this.on("touchstart", _this.onMouseDown, _this);
        _this.on("touchend", _this.onMouseUp, _this);
        _this.on("touchendoutside", _this.onMouseUp, _this);
        _this.on("tap", _this.onMouseClick, _this);
        return _this;
    }

    /**
     * @param {PIXI.Texture} normal
     * @param {PIXI.Texture} [over]
     * @param {PIXI.Texture} [down]
     * @param {PIXI.Texture} [icon]
     */


    _createClass(Button, [{
        key: "destroy",


        /**
         */
        value: function destroy() {
            TweenMax.killTweensOf(this._animation);
            TweenMax.killTweensOf(this._animation.scale);

            this.off("mousedown", this.onMouseDown, this);
            this.off("mouseup", this.onMouseUp, this);
            this.off("mouseupoutside", this.onMouseUp, this);
            this.off("click", this.onMouseClick, this);
            this.off("mouseover", this.onMouseOver, this);
            this.off("mouseout", this.onMouseOut, this);
            this.off("touchstart", this.onMouseDown, this);
            this.off("touchend", this.onMouseUp, this);
            this.off("touchendoutside", this.onMouseUp, this);
            this.off("tap", this.onMouseClick, this);

            this.signals.up.dispose();
            this.signals.down.dispose();
            this.signals.over.dispose();
            this.signals.out.dispose();
            this.signals.click.dispose();
            this.signals.animate.dispose();
            this.signals.focus.dispose();
            this.signals.unfocus.dispose();

            _get(Button.prototype.__proto__ || Object.getPrototypeOf(Button.prototype), "destroy", this).call(this, { children: true });
        }
    }, {
        key: "focus",
        value: function focus() {
            this._focused = true;
            this._focus.visible = true;
            this.signals.focus.dispatch(this);
        }
    }, {
        key: "unfocus",
        value: function unfocus() {
            this._focused = false;
            this._focus.visible = false;
            this.signals.unfocus.dispatch(this);
        }

        /**
         * @param {PIXI.Texture} texture
         * @param {PIXI.Point} offset
         */

    }, {
        key: "setShortcutIcon",
        value: function setShortcutIcon(texture, offset) {
            this._shortcutIcon.texture = texture;
            this._shortcutIcon.position.set(offset.x, offset.y);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseDown",
        value: function onMouseDown(event) {
            this._states.down && (this._background.texture = this._currentDownTexture);
            this._states.iconDown && (this._icon.texture = this._currentIconDownTexture);

            if (this.animate) {
                this.stopAnimations();
                this._tweenDown = this.animateDown();
            }

            Button.audio && this.downSoundName && Button.audio.playSound(this.downSoundName);
            this._enabled && this.signals.down.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseUp",
        value: function onMouseUp(event) {
            this._background.texture = this._states.over && !_ismobilejs2.default.any ? this._currentOverTexture : this._currentNormalTexture;
            if (this._states.iconOver && !_ismobilejs2.default.any) {
                this._icon.texture = this._currentIconOverTexture;
            } else if (this._states.icon) {
                this._icon.texture = this._currentIconTexture;
            }

            if (this.animate && this._tweenDown) {
                this.stopAnimations();
                !_ismobilejs2.default.any ? this._tweenOver = this.animateOver() : this._tweenOut = this.animateOut();
            }

            Button.audio && this.upSoundName && Button.audio.playSound(this.upSoundName);
            this._enabled && this.signals.up.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseUpOutside",
        value: function onMouseUpOutside(event) {
            this._enabled && this.signals.up.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseOver",
        value: function onMouseOver(event) {
            this._states.over && (this._background.texture = this._currentOverTexture);
            this._states.iconOver && (this._icon.texture = this._currentIconOverTexture);

            if (this.animate && !_ismobilejs2.default.any) {
                this.stopAnimations();
                this._tweenOver = this.animateOver();
            }
            if (this.animateIcon && !_ismobilejs2.default.any) {
                TweenMax.killTweensOf(this._icon.scale);
                TweenMax.to(this._icon.scale, 0.8, {
                    x: 1.2,
                    y: 1.2,
                    ease: Elastic.easeOut,
                    easeParams: [1.6]
                });
            }

            Button.audio && this.overSoundName && Button.audio.playSound(this.overSoundName);
            this._enabled && this.signals.over.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseOut",
        value: function onMouseOut(event) {
            this._background.texture = this._currentNormalTexture;
            this._states.icon && (this._icon.texture = this._currentIconTexture);

            this.stopAnimations();
            this._tweenOut = this.animateOut();

            TweenMax.killTweensOf(this._icon.scale);
            TweenMax.to(this._icon.scale, 0.34, {
                x: 1,
                y: 1,
                ease: Power1.easeInOut
            });

            Button.audio && this.upSoundName && Button.audio.playSound(this.upSoundName);
            this._enabled && this.signals.out.dispatch(this, event);
        }

        /**
         * @param {Event} event
         * @protected
         */

    }, {
        key: "onMouseClick",
        value: function onMouseClick(event) {
            Button.audio && this.clickSoundName && Button.audio.playSound(this.clickSoundName);
            this._enabled && this.signals.click.dispatch(this, event);
        }

        /**
         * @returns {TweenMax}
         */

    }, {
        key: "animateOver",
        value: function animateOver() {
            return TweenMax.to(this._animation.scale, 0.6, {
                x: this.animateOverScale.x,
                y: this.animateOverScale.y,
                ease: Elastic.easeOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "over");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "animateOut",


        /**
         * @returns {TweenMax}
         */
        value: function animateOut() {
            return TweenMax.to(this._animation.scale, 0.3, {
                x: 1,
                y: 1,
                ease: Back.easeInOut,
                easeParams: [2],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "out");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "animateDown",


        /**
         * @returns {TweenMax}
         */
        value: function animateDown() {
            return TweenMax.to(this._animation.scale, 0.14, {
                x: this.animateDownScale.x,
                y: this.animateDownScale.y,
                ease: Back.easeOut,
                easeParams: [1],
                onComplete: function onComplete() {
                    this.signals.animate.dispatch(this, "down");
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "stopAnimations",
        value: function stopAnimations() {
            if (this._tweenOut) {
                this._tweenOut.kill();
                this._tweenOut = null;
            }
            if (this._tweenOver) {
                this._tweenOver.kill();
                this._tweenOver = null;
            }
            if (this._tweenDown) {
                this._tweenDown.kill();
                this._tweenDown = null;
            }
        }
    }, {
        key: "setStates",


        /**
         * @param {P3.ButtonStates} states
         */
        value: function setStates(states) {
            this._states = states;
            this._background.texture = this._states.normal;
            this._icon.texture = this._states.icon || PIXI.Texture.EMPTY;

            this._currentNormalTexture = this._states.normal;
            this._currentOverTexture = this._states.over;
            this._currentDownTexture = this._states.down;
            this._currentIconTexture = this._states.icon;
            this._currentIconOverTexture = this._states.iconOver;
            this._currentIconDownTexture = this._states.iconDown;
        }

        /**
         * @returns {ButtonStates}
         */

    }, {
        key: "states",
        get: function get() {
            return this._states.clone();
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentNormalTexture",
        get: function get() {
            return this._currentNormalTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentOverTexture",
        get: function get() {
            return this._currentOverTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentDownTexture",
        get: function get() {
            return this._currentDownTexture;
        }

        /**
         * @returns {PIXI.Texture}
         */

    }, {
        key: "currentIconTexture",
        get: function get() {
            return this._currentIconTexture;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "enabled",
        get: function get() {
            return this._enabled;
        }

        /**
         * @param {boolean} value
         */
        ,
        set: function set(value) {
            this._enabled = value;
            this._currentNormalTexture = value || !this._states.normalInactive ? this._states.normal : this._states.normalInactive;
            this._currentOverTexture = value || !this._states.overInactive ? this._states.over : this._states.overInactive;
            this._currentDownTexture = value || !this._states.downInactive ? this._states.down : this._states.downInactive;
            this._currentIconTexture = value || !this._states.iconInactive ? this._states.icon : this._states.iconInactive;
            this._currentIconOverTexture = value || !this._states.iconOverInactive ? this._states.iconOver : this._states.iconOverInactive;
            this._currentIconDownTexture = value || !this._states.iconDownInactive ? this._states.iconDown : this._states.iconDownInactive;

            this._currentNormalTexture && (this._background.texture = this._currentNormalTexture);
            this._currentIconTexture && (this._icon.texture = this._currentIconTexture);
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "focused",
        get: function get() {
            return this._focused;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "tint",
        get: function get() {
            return this._background.tint;
        }

        /**
         * @param {number} value
         */
        ,
        set: function set(value) {
            this._background.tint = value;
            this._icon.tint = value;
        }

        /**
         * @returns {PIXI.Container}
         */

    }, {
        key: "animation",
        get: function get() {
            return this._animation;
        }
    }], [{
        key: "create",
        value: function create(normal, over, down, icon) {
            var states = new _ButtonStates2.default(normal, over, down, icon);
            return new Button(states);
        }
    }]);

    return Button;
}(PIXI.Container);

exports.default = Button;

},{"./ButtonStates":10,"ismobilejs":1}],10:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var ButtonStates = function () {
  /**
   * @param {PIXI.Texture} normal
   * @param {PIXI.Texture} [over]
   * @param {PIXI.Texture} [down]
   * @param {PIXI.Texture} [icon]
   */
  function ButtonStates(normal, over, down, icon) {
    _classCallCheck(this, ButtonStates);

    /**
     * @member {PIXI.Texture}
     */
    this.normal = normal;

    /**
     * @member {PIXI.Texture}
     */
    this.over = over || null;

    /**
     * @member {PIXI.Texture}
     */
    this.down = down || null;

    /**
     * @member {PIXI.Texture}
     */
    this.focus = null;

    /**
     * @member {PIXI.Texture}
     */
    this.icon = icon || null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOver = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDown = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOverAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDownAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconOverInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconDownInactive = null;

    /**
     * @member {PIXI.Texture}
     */
    this.normalInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.overInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.downInactiveAlt = null;

    /**
     * @member {PIXI.Texture}
     */
    this.iconInactiveAlt = null;
  }

  /**
   * @returns {ButtonStates}
   */


  _createClass(ButtonStates, [{
    key: "clone",
    value: function clone() {
      var states = new ButtonStates(this.normal);
      states.over = this.over;
      states.down = this.down;
      states.over = this.over;
      states.focus = this.focus;
      states.icon = this.icon;
      states.iconOver = this.iconOver;
      states.iconDown = this.iconDown;
      states.normalAlt = this.normalAlt;
      states.downAlt = this.downAlt;
      states.overAlt = this.overAlt;
      states.iconAlt = this.iconAlt;
      states.iconOverAlt = this.iconOverAlt;
      states.iconDownAlt = this.iconDownAlt;
      states.normalInactive = this.normalInactive;
      states.downInactive = this.downInactive;
      states.overInactive = this.overInactive;
      states.iconInactive = this.iconInactive;
      states.iconDownInactive = this.iconDownInactive;
      states.iconOverInactive = this.iconOverInactive;
      states.normalInactiveAlt = this.normalInactiveAlt;
      states.downInactiveAlt = this.downInactiveAlt;
      states.overInactiveAlt = this.overInactiveAlt;
      states.iconInactiveAlt = this.iconInactiveAlt;
      return states;
    }
  }]);

  return ButtonStates;
}();

exports.default = ButtonStates;

},{}],11:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Vector = require("../math/Vector2");

var _Vector2 = _interopRequireDefault(_Vector);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var Input = function () {
    function Input() {
        _classCallCheck(this, Input);

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.mouseMove
         * @member {signals.Signal} signals.mouseDown
         * @member {signals.Signal} signals.mouseUp
         * @member {signals.Signal} signals.mouseClick
         * @member {signals.Signal} signals.keyDown
         * @member {signals.Signal} signals.keyUp
         * @member {signals.Signal} signals.swipeLeft
         * @member {signals.Signal} signals.swipeRight
         * @member {signals.Signal} signals.swipeUp
         * @member {signals.Signal} signals.swipeDown
         * @member {signals.Signal} signals.orientation
         */
        this.signals = {
            mouseMove: new signals.Signal(),
            mouseDown: new signals.Signal(),
            mouseUp: new signals.Signal(),
            mouseClick: new signals.Signal(),
            keyDown: new signals.Signal(),
            keyUp: new signals.Signal(),
            swipeLeft: new signals.Signal(),
            swipeRight: new signals.Signal(),
            swipeUp: new signals.Signal(),
            swipeDown: new signals.Signal(),
            orientation: new signals.Signal()
        };

        /**
         * The element listening for key strokes will be focused when the document is clicked.
         * @member {boolean}
         */
        this.refocus = true;

        /**
         * @member {PIXI.DisplayObject}
         * @private
         */
        this._stage = null;

        /**
         * @member {*}
         * @private
         */
        this._keyListener = null;

        /**
         * @member {Object}
         * @private
         */
        this._keyMap = {};

        /**
         * @member {Object}
         * @private
         */
        this._keyBuffer = {};

        /**
         * @member {PIXI.Point}
         * @private
         */
        this._touch = null;

        /**
         * @member {null}
         * @private
         */
        this._swipeStart = null;

        /**
         * @member {number}
         * @private
         */
        this._swipeTime = 0;

        /**
         * @member {Object} orientation
         * @member {number} orientation.gamma
         * @member {number} orientation.beta
         * @member {number} orientation.alpha
         * @private
         */
        this._orientation = {
            gamma: 0,
            beta: 0,
            alpha: 0
        };

        /**
         * @member
         * @private
         */
        this._func = {};
    }

    /**
     * @param {PIXI.DisplayObject} stage
     * @param {*} keyListener
     */


    _createClass(Input, [{
        key: "init",
        value: function init(stage, keyListener) {
            this._stage = stage;
            this._stage.interactive = true;
            this._stage.on("mousemove", this.onMouseMove, this);
            this._stage.on("mousedown", this.onMouseDown, this);
            this._stage.on("mouseup", this.onMouseUp, this);
            this._stage.on("click", this.onMouseClick, this);
            this._stage.on("touchmove", this.onMouseMove, this);
            this._stage.on("touchstart", this.onMouseDown, this);
            this._stage.on("touchend", this.onMouseUp, this);
            this._stage.on("tap", this.onMouseClick, this);

            this._keyListener = keyListener;
            this._keyListener.addEventListener("keydown", this._func.keydown = this.onKeyDown.bind(this));
            this._keyListener.addEventListener("keyup", this._func.keyup = this.onKeyUp.bind(this));
            this._keyListener.focus();

            document.addEventListener("click", this._func.click = function () {
                this.refocus && this._keyListener.focus();
            }.bind(this));

            _ismobilejs2.default.any && window.addEventListener("deviceorientation", this._func.deviceorientation = this.onDeviceOrientation.bind(this));
        }
    }, {
        key: "destroy",
        value: function destroy() {
            this._stage.off("mousemove", this.onMouseMove, this);
            this._stage.off("mousedown", this.onMouseDown, this);
            this._stage.off("mouseup", this.onMouseUp, this);
            this._stage.off("click", this.onMouseClick, this);
            this._stage.off("touchmove", this.onMouseMove, this);
            this._stage.off("touchstart", this.onMouseDown, this);
            this._stage.off("touchend", this.onMouseUp, this);
            this._stage.off("tap", this.onMouseClick, this);

            this._keyListener.removeEventListener("keydown", this._func.keydown);
            this._keyListener.removeEventListener("keyup", this._func.keyup);

            document.removeEventListener("click", this._func.click);

            _ismobilejs2.default.any && window.removeEventListener("deviceorientation", this._func.deviceorientation);

            this.signals.mouseMove.dispose();
            this.signals.mouseDown.dispose();
            this.signals.mouseUp.dispose();
            this.signals.mouseClick.dispose();

            this.signals.keyDown.dispose();
            this.signals.keyUp.dispose();

            this.signals.swipeLeft.dispose();
            this.signals.swipeRight.dispose();
            this.signals.swipeUp.dispose();
            this.signals.swipeDown.dispose();

            this.signals.orientation.dispose();
        }

        /**
         */

    }, {
        key: "update",
        value: function update() {
            for (var i in this._keyBuffer) {
                if (this._keyBuffer.hasOwnProperty(i)) {
                    this._keyBuffer[i] = false;
                }
            }
        }

        /**
         * @param {number} keyCode
         * @returns {boolean}
         */

    }, {
        key: "isKeyDown",
        value: function isKeyDown(keyCode) {
            return this._keyMap[keyCode] === true;
        }

        /**
         * @param {number} keyCode
         * @returns {boolean}
         */

    }, {
        key: "isKeyPressed",
        value: function isKeyPressed(keyCode) {
            return this._keyBuffer[keyCode] === true;
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onMouseMove",
        value: function onMouseMove(event) {
            this._touch && (this._touch = event.data.getLocalPosition(this._stage));

            this.signals.mouseMove.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onMouseDown",
        value: function onMouseDown(event) {
            this._touch = event.data.getLocalPosition(this._stage);

            if (_ismobilejs2.default.any) {
                this._swipeStart = this._touch.clone();
                this._swipeTime = window.performance.now();
            }
            this.signals.mouseDown.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onMouseUp",
        value: function onMouseUp(event) {
            if (_ismobilejs2.default.any) {
                var swipe = new _Vector2.default(this._touch.x - this._swipeStart.x, this._touch.y - this._swipeStart.y);
                var distance = swipe.lengthSq;
                var minimum = 4 * 4;
                swipe.normalize();

                if (window.performance.now() - this._swipeTime < 800 && distance > minimum) {
                    var left = swipe.dot(new _Vector2.default(-1, 0));
                    left > 0.9 && this.signals.swipeLeft.dispatch();

                    var right = swipe.dot(new _Vector2.default(1, 0));
                    right > 0.9 && this.signals.swipeRight.dispatch();

                    var up = swipe.dot(new _Vector2.default(0, -1));
                    up > 0.9 && this.signals.swipeUp.dispatch();

                    var down = swipe.dot(new _Vector2.default(0, 1));
                    down > 0.9 && this.signals.swipeDown.dispatch();
                }
            }

            this._touch = null;
            this.signals.mouseUp.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onMouseClick",
        value: function onMouseClick(event) {
            this.signals.mouseClick.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onKeyDown",
        value: function onKeyDown(event) {
            if (event.keyCode === Input.keys.LEFT || event.keyCode === Input.keys.RIGHT || event.keyCode === Input.keys.UP || event.keyCode === Input.keys.DOWN || event.keyCode === Input.keys.SPACE) event.preventDefault();

            !this.isKeyDown(event.keyCode) && (this._keyBuffer[event.keyCode] = true);
            this._keyMap[event.keyCode] = true;
            this.signals.keyDown.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onKeyUp",
        value: function onKeyUp(event) {
            if (event.keyCode === Input.keys.LEFT || event.keyCode === Input.keys.RIGHT || event.keyCode === Input.keys.UP || event.keyCode === Input.keys.DOWN || event.keyCode === Input.keys.SPACE) event.preventDefault();

            this._keyMap[event.keyCode] = false;
            this.signals.keyUp.dispatch(event);
        }

        /**
         * @param {Event} event
         */

    }, {
        key: "onDeviceOrientation",
        value: function onDeviceOrientation(event) {
            this.signals.orientation.dispatch(event);
        }

        /**
         * @returns {PIXI.Point}
         */

    }, {
        key: "touch",
        get: function get() {
            return this._touch;
        }

        /**
         * @returns {Object} orientation
         * @returns {number} orientation.gamma
         * @returns {number} orientation.beta
         * @returns {number} orientation.alpha
         */

    }, {
        key: "orientation",
        get: function get() {
            return this._orientation;
        }
    }]);

    return Input;
}();

/**
 * @static
 * @constant
 * @type {Object}
 */


exports.default = Input;
Input.keys = {
    TAB: 9,
    ENTER: 13,
    SHIFT: 16,
    CTRL: 17,
    SPACE: 32,
    LEFT: 37,
    UP: 38,
    RIGHT: 39,
    DOWN: 40,
    NUM_0: 48,
    NUM_1: 49,
    NUM_2: 50,
    NUM_3: 51,
    NUM_4: 52,
    NUM_5: 53,
    NUM_6: 54,
    NUM_7: 55,
    NUM_8: 56,
    NUM_9: 57,
    A: 65,
    B: 66,
    C: 67,
    D: 68,
    E: 69,
    F: 70,
    G: 71,
    H: 72,
    I: 73,
    J: 74,
    K: 75,
    L: 76,
    M: 77,
    N: 78,
    O: 79,
    P: 80,
    Q: 81,
    R: 82,
    S: 83,
    T: 84,
    U: 85,
    V: 86,
    W: 87,
    X: 88,
    Y: 89,
    Z: 90,
    PLUS: 187,
    MINUS: 189
};

},{"../math/Vector2":23,"ismobilejs":1}],12:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _MovieClipSequence = require("./MovieClipSequence");

var _MovieClipSequence2 = _interopRequireDefault(_MovieClipSequence);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var MovieClip = function (_PIXI$Sprite) {
    _inherits(MovieClip, _PIXI$Sprite);

    /**
     * @param {MovieClipSequence} sequence
     * @param {string} [defaultAnimation=default]
     * @param {boolean} [autoUpdate=true]
     */
    function MovieClip(sequence) {
        var defaultAnimation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "default";
        var autoUpdate = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

        _classCallCheck(this, MovieClip);

        var texture = sequence.textures[defaultAnimation] ? sequence.textures[defaultAnimation][0] : PIXI.Texture.EMPTY;
        if (!texture) {
            throw new Error("No default texture found!");
        }

        /**
         * @member {number}
         */
        var _this = _possibleConstructorReturn(this, (MovieClip.__proto__ || Object.getPrototypeOf(MovieClip)).call(this, texture));

        _this.animationSpeed = 24;

        /**
         * @member {boolean}
         */
        _this.looping = false;

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.animation
         * @member {signals.Signal} signals.animationComplete
         */
        _this.signals = {
            animation: new signals.Signal(),
            animationComplete: new signals.Signal()
        };

        /**
         * @member {*}
         * @protected
         */
        _this._frames = {};

        /**
         * @member {boolean}
         * @protected
         */
        _this._playing = false;

        /**
         * @member {string}
         * @protected
         */
        _this._defaultAnimation = defaultAnimation;

        /**
         * @member {number}
         * @protected
         */
        _this._currentFrame = 0;

        /**
         * @member {number}
         * @protected
         */
        _this._lastFrame = 0;

        /**
         * @member {string}
         * @protected
         */
        _this._currentAnimationName = _this._defaultAnimation;

        /**
         * @type {boolean}
         * @protected
         */
        _this._autoUpdate = false;

        for (var i in sequence.textures) {
            if (sequence.textures.hasOwnProperty(i)) {
                _this._frames[i] = [];
                for (var j = 0; j < sequence.textures[i].length; ++j) {
                    _this._frames[i].push({
                        texture: sequence.textures[i][j],
                        callback: null,
                        scope: null
                    });
                }
            }
        }
        _this.autoUpdate = autoUpdate;
        return _this;
    }

    /**
     * @param {object} options
     * @param {boolean} [options.children=false]
     * @param {boolean} [options.texture=false]
     * @param {boolean} [options.baseTexture=false]
     */


    _createClass(MovieClip, [{
        key: "destroy",
        value: function destroy(options) {
            this.signals.animation.dispose();
            this.signals.animationComplete.dispose();

            this.autoUpdate = false;

            _get(MovieClip.prototype.__proto__ || Object.getPrototypeOf(MovieClip.prototype), "destroy", this).call(this, options);
        }

        /**
         * @param {boolean} [looping]
         */

    }, {
        key: "play",
        value: function play(looping) {
            if (typeof looping === "boolean") {
                this.looping = looping;
            }
            this._playing = true;
        }
    }, {
        key: "stop",
        value: function stop() {
            this._playing = false;
        }

        /**
         * @param {number|string} frame
         * @param {boolean} looping
         */

    }, {
        key: "gotoAndPlay",
        value: function gotoAndPlay(frame, looping) {
            if (typeof frame !== "string") {
                this._currentFrame = this._lastFrame = frame;
            } else if (this._frames[frame]) {
                this._currentFrame = this._lastFrame = 0;
                this._currentAnimationName = frame;
            }
            if (typeof looping === "boolean") {
                this.looping = looping;
            }
            this._playing = true;
        }

        /**
         * @param {number|string} frame
         */

    }, {
        key: "gotoAndStop",
        value: function gotoAndStop(frame) {
            if (typeof frame !== "string") {
                this._currentFrame = frame;
            } else if (this._frames[frame]) {
                this._currentFrame = 0;
                this._currentAnimationName = frame;
            }
            this._playing = false;

            var frames = this._frames[this._currentAnimationName];
            var round = this._currentFrame + 0.5 | 0;
            this.texture = frames[round % frames.length].texture;
        }

        /**
         * @param {number} frame
         * @param {function} callback
         * @param {*} [scope]
         * @param {string} [name=default]
         */

    }, {
        key: "addFrameScript",
        value: function addFrameScript(frame, callback, scope) {
            var name = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : "default";

            scope = scope || window;
            if (this._frames[name]) {
                this._frames[name][frame].callback = callback;
                this._frames[name][frame].scope = callback ? scope | window : null;
            }
        }

        /**
         * @param {number} dt
         */

    }, {
        key: "update",
        value: function update(dt) {
            if (!this._playing || !this.getTotalFrames()) return;

            this._autoUpdate && (dt = dt / PIXI.settings.TARGET_FPMS / 1000);
            this._currentFrame += this.animationSpeed * dt;

            var frames = this._frames[this._currentAnimationName];
            var round = this._currentFrame + 0.5 | 0;
            var index = round % (frames.length + 1);

            this._currentFrame = this._currentFrame % frames.length;
            if (index > 0 && index !== this._lastFrame) {
                this._lastFrame = index;
                frames[index - 1].callback && frames[index - 1].callback.call(frames[index - 1].scope);
            }

            if (this.looping || round < frames.length) {
                this.texture = frames[round % frames.length].texture;
                if (round >= frames.length - 1) {
                    this.signals.animation.dispatch(this, this._currentAnimationName);
                }
            } else if (round >= frames.length - 1) {
                this.gotoAndStop(frames.length - 1);
                this.signals.animationComplete.dispatch(this, this._currentAnimationName);
            }
        }

        /**
         * @param {string} [name]
         * @returns {number}
         */

    }, {
        key: "getTotalFrames",
        value: function getTotalFrames(name) {
            name = name || this._defaultAnimation;
            var frames = this._frames[name];
            return frames ? frames.length : 0;
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "playing",
        get: function get() {
            return this._playing;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "currentFrame",
        get: function get() {
            return this._currentFrame;
        }

        /**
         * @returns {string}
         */

    }, {
        key: "currentAnimationFrame",
        get: function get() {
            return this._currentAnimationName;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "totalFrames",
        get: function get() {
            return this.getTotalFrames();
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "autoUpdate",
        get: function get() {
            return this._autoUpdate;
        }

        /**
         * @param {boolean} value
         */
        ,
        set: function set(value) {
            var ticker = PIXI.ticker.shared;
            if (this._autoUpdate && !value) {
                ticker.remove(this.update, this);
            } else if (!this._autoUpdate && value) {
                ticker.add(this.update, this);
            }
            this._autoUpdate = value;
        }
    }]);

    return MovieClip;
}(PIXI.Sprite);

exports.default = MovieClip;

},{"./MovieClipSequence":13}],13:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3
 */
var MovieClipSequence = function (_PIXI$Container) {
    _inherits(MovieClipSequence, _PIXI$Container);

    function MovieClipSequence(textures, name) {
        _classCallCheck(this, MovieClipSequence);

        /**
         * @type {object} textures
         */
        var _this = _possibleConstructorReturn(this, (MovieClipSequence.__proto__ || Object.getPrototypeOf(MovieClipSequence)).call(this));

        _this.textures = {};

        textures && _this.addTextures(textures, name);
        return _this;
    }

    /**
     * @param {Array.<PIXI.Texture>} textures
     * @param {string} [name]
     */


    _createClass(MovieClipSequence, [{
        key: "addTextures",
        value: function addTextures(textures, name) {
            name = name || "default";
            this.textures[name] = textures;
        }

        /**
         * @param {string} [name]
         */

    }, {
        key: "removeTextures",
        value: function removeTextures(name) {
            name = name || "default";
            this.textures[name] = null;
        }

        /**
         */

    }, {
        key: "removeAllTextures",
        value: function removeAllTextures() {
            this.textures = {};
        }
    }]);

    return MovieClipSequence;
}(PIXI.Container);

exports.default = MovieClipSequence;

},{}],14:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Button2 = require("./Button");

var _Button3 = _interopRequireDefault(_Button2);

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends P3.Button
 */
var MuteButton = function (_Button) {
    _inherits(MuteButton, _Button);

    /**
     * @param {ButtonStates} states
     */
    function MuteButton(states) {
        _classCallCheck(this, MuteButton);

        var _this = _possibleConstructorReturn(this, (MuteButton.__proto__ || Object.getPrototypeOf(MuteButton)).call(this, states));

        _this._currentIconTexture = _this.isEnabled() ? _this._states.icon : _this._states.iconAlt;
        _this._currentIconOverTexture = _this.isEnabled() ? _this._states.iconOver : _this._states.iconOverAlt;
        _this._currentIconDownTexture = _this.isEnabled() ? _this._states.iconDown : _this._states.iconDownAlt;

        _this._icon.texture = _this._states.iconOver && !_ismobilejs2.default.any ? _this._currentIconOverTexture : _this._currentIconTexture;
        return _this;
    }

    /**
     * @param {Event} event
     * @private
     */


    _createClass(MuteButton, [{
        key: "onMouseClick",
        value: function onMouseClick(event) {
            this._currentIconTexture = !this.isEnabled() ? this._states.icon : this._states.iconAlt;
            this._currentIconOverTexture = !this.isEnabled() ? this._states.iconOver : this._states.iconOverAlt;
            this._currentIconDownTexture = !this.isEnabled() ? this._states.iconDown : this._states.iconDownAlt;

            this._icon.texture = this._states.iconOver && !_ismobilejs2.default.any ? this._currentIconOverTexture : this._currentIconTexture;

            if (!!_Button3.default.audio) {
                _Button3.default.audio.mute(!_Button3.default.audio.isMute);
            }
            _get(MuteButton.prototype.__proto__ || Object.getPrototypeOf(MuteButton.prototype), "onMouseClick", this).call(this, event);
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isEnabled",
        value: function isEnabled() {
            return !!_Button3.default.audio && !_Button3.default.audio.isMute;
        }
    }]);

    return MuteButton;
}(_Button3.default);

exports.default = MuteButton;

},{"./Button":9,"ismobilejs":1}],15:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TweenList = require("../utils/TweenList");

var _TweenList2 = _interopRequireDefault(_TweenList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; } /**
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @class
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @extends PIXI.Container
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                * @memberOf P3
                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                */


var Scene = function (_PIXI$Container) {
    _inherits(Scene, _PIXI$Container);

    function Scene() {
        _classCallCheck(this, Scene);

        /**
         * @member {object} signals
         * @member {signals.Signal} signals.next
         * @member {signals.Signal} signals.previous
         * @member {signals.Signal} signals.home
         * @member {signals.Signal} signals.pause
         */
        var _this = _possibleConstructorReturn(this, (Scene.__proto__ || Object.getPrototypeOf(Scene)).call(this));

        _this.signals = {
            next: new signals.Signal(),
            previous: new signals.Signal(),
            home: new signals.Signal(),
            pause: new signals.Signal()
        };

        /**
         * @member {boolean} - The scene has finished loading its required manifest.
         */
        _this.loaded = false;

        /**
         * @member {boolean} - The scene is always updated regardless of its place in the stack.
         */
        _this.alwaysUpdate = false;

        /**
         * @member {boolean} - The scene will call appear automatically.
         */
        _this.autoAppear = true;

        /**
         * @member {TweenList}
         * @private
         */
        _this._tweenList = new _TweenList2.default();
        return _this;
    }

    /**
     * @returns {Scene}
     */


    _createClass(Scene, [{
        key: "preloader",
        value: function preloader() {
            return new Scene();
        }

        /**
         * @returns {Array}
         */

    }, {
        key: "load",
        value: function load() {
            return [];
        }
    }, {
        key: "unload",
        value: function unload() {}
        // override


        /**
         * This method is called when a scene is initialized.
         */

    }, {
        key: "init",
        value: function init() {}
        // override


        /**
         * This method is called when a scene is destroyed.
         *
         * @param options
         * @param [options.children=false]
         * @param [options.texture=false]
         * @param [options.baseTexture=false]
         */

    }, {
        key: "destroy",
        value: function destroy(options) {
            this.signals.next.dispose();
            this.signals.previous.dispose();
            this.signals.home.dispose();
            this.signals.pause.dispose();

            this._tweenList.destroy();

            _get(Scene.prototype.__proto__ || Object.getPrototypeOf(Scene.prototype), "destroy", this).call(this, options);
        }

        /**
         * This method is called when the device dimensions are changed.
         */

    }, {
        key: "resize",
        value: function resize() {}
        // override


        /**
         * This method is called when the scene is 'top' of the stack.
         */

    }, {
        key: "update",
        value: function update() {}
        // override


        /**
         * This method is called when the scene is shown for the first time.
         */

    }, {
        key: "appear",
        value: function appear() {
            this.animateIn();
        }

        /**
         * This method is called when the scene is shown - regardless of actual visibility.
         */

    }, {
        key: "show",
        value: function show() {}

        /**
         * This method is called when the scene is hidden - regardless of actual visibility.
         */

    }, {
        key: "hide",
        value: function hide() {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateIn",
        value: function animateIn(callback, scope) {}

        /**
         * @param {function} [callback]
         * @param {*} [scope]
         */

    }, {
        key: "animateOut",
        value: function animateOut(callback, scope) {}

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to add to the scene.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was added.
         * @deprecated
         */

    }, {
        key: "addTween",
        value: function addTween(tween) {
            this._tweenList.add(tween);
            return tween;
        }

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to remove from the scene.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was removed.
         * @deprecated
         */

    }, {
        key: "removeTween",
        value: function removeTween(tween) {
            this._tweenList.remove(tween);
            return tween;
        }

        /**
         * @returns {TweenList}
         */

    }, {
        key: "tweenList",
        get: function get() {
            return this._tweenList;
        }
    }]);

    return Scene;
}(PIXI.Container);

exports.default = Scene;

},{"../utils/TweenList":38}],16:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _Scene = require("./Scene");

var _Scene2 = _interopRequireDefault(_Scene);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var SceneManager = function () {
    /**
     * @param {PIXI.CanvasRenderer|PIXI.WebGLRenderer} renderer
     */
    function SceneManager(renderer) {
        _classCallCheck(this, SceneManager);

        /**
         * @member {Object}
         * @member {signals.Signal} signals.next
         */
        this.signals = {
            next: new signals.Signal()
        };

        /**
         * @member {PIXI.Container}
         * @private
         */
        this._view = new PIXI.Container();

        /**
         * @member {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
         * @private
         */
        this._renderer = renderer;

        /**
         * @member {Object}
         * @private
         */
        this._next = null;

        /**
         * @type {Array.<Scene>}
         * @private
         */
        this._stack = [];
    }

    /**
     * Shows the next Scene. This will destroy all current scenes and remove them from the stack.
     * @param {Scene} scene - The scene to show.
     */


    _createClass(SceneManager, [{
        key: "show",
        value: function show(scene) {
            this._next = {};
            this._next.type = 0;
            this._next.scene = scene;
        }

        /**
         * @param {Scene} scene - The scene to add.
         * @param {boolean} [replace] - All other scenes are removed from the display list but will remain in the stack.
         */

    }, {
        key: "add",
        value: function add(scene, replace) {
            this._next = {};
            this._next.type = 1;
            this._next.scene = scene;
            this._next.replace = replace;
        }

        /**
         * @param {Scene} scene - The scene to add.
         * @param {number} [count=1] - The number of scenes to swap with the new scene.
         */

    }, {
        key: "swap",
        value: function swap(scene, count) {
            this._next = {};
            this._next.type = 2;
            this._next.scene = scene;
            this._next.removeCount = Math.max(1, count) || 1;
        }

        /**
         * Remove a Scene from the top of the stack.
         * @param {number} [count=1] - The number of scenes to remove from the stack.
         */

    }, {
        key: "remove",
        value: function remove(count) {
            this._next = {};
            this._next.type = 2;
            this._next.removeCount = Math.max(1, count) || 1;
        }

        /**
         * Remove all Scenes from the stack.
         */

    }, {
        key: "removeAll",
        value: function removeAll() {
            this._next = {};
            this._next.type = 3;
            this._next.removeCount = Number.MAX_SAFE_INTEGER;
        }

        /**
         * Destroys all Scenes in the stack.
         */

    }, {
        key: "clear",
        value: function clear() {
            if (this._transitionInProgress) return;

            for (var i = 0; i < this._stack.length; ++i) {
                var scene = this._stack[i];
                if (scene.parent) {
                    scene.hide();
                    scene.parent.removeChild(scene);
                }
                scene.destroy({ children: true });
            }
            this._stack.length = 0;
        }

        /**
         * Updates the Scene at the top of the stack.
         */

    }, {
        key: "update",
        value: function update() {
            this._next && this._nextScene();

            if (this._stack.length) {
                this.top.update();
                for (var i = 0; i < this._stack.length - 1; ++i) {
                    var scene = this._stack[i];
                    scene.alwaysUpdate && scene.update();
                }
            }
        }

        /**
         * Attempts to resize any children added to the SceneManagers view.
         */

    }, {
        key: "resize",
        value: function resize() {
            for (var i = 0; i < this._view.children.length; ++i) {
                var child = this._view.children[i];
                child.resize && child.resize();
            }
        }

        /**
         * @private
         */

    }, {
        key: "_nextScene",
        value: function _nextScene() {
            var next = this._next;
            this._next = null;

            var scene = next.scene;

            if (this.top) {
                this.top.hide();

                switch (next.type) {
                    // show
                    case 0:
                        {
                            while (this.top) {
                                this._removeTop();
                            }break;
                        }
                    // add
                    case 1:
                        {
                            if (next.replace) {
                                for (var i = this._stack.length - 1; i >= 0; --i) {
                                    var other = this._stack[i];
                                    other.parent && other.parent.removeChild(other);
                                }
                            }
                            break;
                        }
                    // remove
                    case 2:
                        {
                            var count = Math.min(this._stack.length, next.removeCount);
                            for (var _i = 0; _i < count; ++_i) {
                                this._removeTop();
                            }
                            break;
                        }
                }
            }

            if (scene) {

                this._stack.push(scene);
                scene.init();
            } else {
                scene = this.top;
            }

            if (scene) {
                scene.resize();
                !scene.parent && this._view.addChild(scene);

                scene.show();
                if (next.type !== 2 && scene.autoAppear) {
                    scene.appear();
                }
            }

            console.log("stack:", this._stack);
            this.signals.next.dispatch(this, scene);
        }

        /**
         * @private
         */

    }, {
        key: "_removeTop",
        value: function _removeTop() {
            this.top.parent && this.top.parent.removeChild(this.top);
            this.top.destroy({ children: true });
            this.top.unload();
            this._stack.pop();
        }

        /**
         * @returns {PIXI.Container}
         */

    }, {
        key: "view",
        get: function get() {
            return this._view;
        }

        /**
         * @returns {PIXI.CanvasRenderer|PIXI.WebGLRenderer}
         */

    }, {
        key: "renderer",
        get: function get() {
            return this._renderer;
        }

        /**
         * The top most Scene in the stack.
         * @returns {Scene}
         */

    }, {
        key: "top",
        get: function get() {
            return this._stack.length ? this._stack[this._stack.length - 1] : null;
        }
    }]);

    return SceneManager;
}();

exports.default = SceneManager;

},{"./Scene":15}],17:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var Ticker = function () {
    function Ticker() {
        _classCallCheck(this, Ticker);

        this._accumulator = 0;
        this._lastFrameTimeMs = 0;
    }

    /**
     * @param {function} update
     * @param {function} render
     * @param {*} [scope]
     */


    _createClass(Ticker, [{
        key: "init",
        value: function init(update, render, scope) {
            var _this2 = this;

            scope = scope || window;

            function tick(timestamp) {
                var _this = this;

                this._accumulator += timestamp - this._lastFrameTimeMs;
                this._lastFrameTimeMs = timestamp;

                var i = 0;
                while (this._accumulator >= Ticker.TARGET_FPMS) {
                    update.call(scope);
                    this._accumulator -= Ticker.TARGET_FPMS;

                    if (++i >= 240) {
                        this._accumulator = 0;
                        console.warn("update is taking too long!");
                        break;
                    }
                }
                render.call(scope);
                requestAnimationFrame(function (timestamp) {
                    tick.call(_this, timestamp);
                });
            }
            requestAnimationFrame(function (timestamp) {
                tick.call(_this2, timestamp);
            });
        }
    }]);

    return Ticker;
}();

/**
 * @static
 * @type {number}
 */


exports.default = Ticker;
Ticker.TARGET_FPMS = 1000 / 60;

/**
 * @static
 * @type {number}
 */
Ticker.dt = Ticker.TARGET_FPMS / 1000;

},{}],18:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ismobilejs = require("ismobilejs");

var _ismobilejs2 = _interopRequireDefault(_ismobilejs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3
 */
var View = function () {
    /**
     * @param {Object} [options]
     * @param {boolean} [options.width=0]
     * @param {number} [options.height=0]
     * @param {string} [options.holderId]
     * @param {boolean} [options.portrait=false]
     * @param {string} [options.rotateImageUrl]
     * @param {number} [options.rotateImageColor=0xFFFFFF]
     * @param {boolean} [options.aspectRatioFillHeight=true]
     */
    function View(options) {
        _classCallCheck(this, View);

        /**
         * @member {Object}
         */
        this.signals = {};

        /**
         * @member {signals.Signal}
         */
        this.signals.ready = new signals.Signal();

        /**
         * @member {signals.Signal}
         */
        this.signals.resize = new signals.Signal();

        /**
         * @type {Object}
         * @private
         */
        this._options = Object.assign({}, {
            width: 0,
            height: 0,
            holderId: "game",
            portrait: false,
            rotateImageColor: 0xFFFFFF,
            aspectRatioFillHeight: true
        }, options);

        /**
         * @member {Element}
         * @private
         */
        this._holder = null;

        /**
         * @member {Element}
         * @private
         */
        this._canvas = null;

        /**
         * @member {Element}
         * @private
         */
        this._iosfix = null;

        /**
         * @member {Element}
         * @private
         */
        this._rotateImage = null;

        /**
         * @type {string}
         * @private
         */
        this._targetOrientation = this._options.portrait ? "portrait" : "landscape";
    }

    _createClass(View, [{
        key: "init",
        value: function init() {
            var _this = this;

            if (document.readyState === "complete" || P3.utils.isCocoonJS()) {
                this._onLoad();
            } else {
                window.self.onload = function () {
                    setTimeout(function () {
                        _this._onLoad();
                    }, 0);
                };
            }
        }

        /**
         */

    }, {
        key: "resize",
        value: function resize() {
            var width = _ismobilejs2.default.any ? document.documentElement.clientWidth : window.innerWidth;
            var height = _ismobilejs2.default.any ? document.documentElement.clientHeight : window.innerHeight;

            if (window.self === window.top) {
                this._holder.style.width = width + "px";
                this._holder.style.height = height + "px";
            } else {
                this._holder.style.width = "100%";
                this._holder.style.height = "100%";
            }

            if (_ismobilejs2.default.apple.device) {
                this._iosfix.style.height = parseInt(this._holder.style.height) + 1 + "px";
            }

            // this scroll is used in IOS 8.0+ to move the game down when the user clicks to show the scrollbar.
            window.scrollTo(0, 0);

            if (this._options.aspectRatioFillHeight) {
                var ratioW = width / this._options.width;
                var ratioH = this._options.height / height;

                this._updateDimensions(Math.floor(this._options.width * ratioW * ratioH), this._options.height);
            } else {
                var _ratioW = this._options.width / width;
                var _ratioH = height / this._options.height;

                this._updateDimensions(this._options.width, Math.floor(this._options.height * _ratioH * _ratioW));
            }

            this.toggleRotate(!this.isCorrectOrientation);
            this.signals.resize.dispatch(this.isCorrectOrientation);
        }

        /**
         * @param {boolean} value
         */

    }, {
        key: "toggleRotate",
        value: function toggleRotate(value) {
            this._canvas.style.display = value ? "none" : "block";
            this._rotateImage.style.display = value ? "block" : "none";
        }

        /**
         * @private
         */

    }, {
        key: "_createHolder",
        value: function _createHolder() {
            if (P3.utils.isCocoonJS()) return;

            this._holder = document.getElementById(this._options.holderId);
            if (!this._holder) {
                this._holder = document.createElement("div");
                this._holder.id = this._options.holderId;
                document.body.appendChild(this._holder);
            }

            this._holder.style.position = "absolute";
            this._holder.style.left = 0;
            this._holder.style.top = 0;
            this._holder.style.width = window.self.innerWidth + "px";
            this._holder.style.height = window.self.innerHeight + "px";
            View.holder = this._holder;

            // forces the browser bars to be hidden in iOS9
            if (_ismobilejs2.default.apple.device) {
                this._iosfix = document.createElement("div");
                this._iosfix.id = "iosfix";
                this._iosfix.style.position = "absolute";
                this._iosfix.style.left = 0;
                this._iosfix.style.right = 0;
                this._iosfix.style.top = 0;
                this._iosfix.style.bottom = 0;
                this._iosfix.style.width = "100%";
                this._iosfix.style.height = this._holder.height + 1;
                this._iosfix.style.visibility = "hidden";
                document.body.appendChild(this._iosfix);
                View.iosfix = this._iosfix;
            }
        }

        /**
         * @private
         */

    }, {
        key: "_createCanvas",
        value: function _createCanvas() {
            if (P3.utils.isCocoonJS()) {
                this._canvas = document.createElement("screencanvas");
                this._canvas.id = "canvas";
                this._canvas.width = this._options.width;
                this._canvas.height = this._options.height;
                this._canvas.style.cssText = "idtkscale:ScaleAspectFill;";
                document.body.appendChild(this._canvas);
            } else {
                this._canvas = document.createElement("canvas");
                this._canvas.id = "canvas";
                this._canvas.tabIndex = 1;
                this._canvas.style.position = "absolute";
                this._canvas.style.left = 0;
                this._canvas.style.right = 0;
                this._canvas.style.top = 0;
                this._canvas.style.bottom = 0;
                this._canvas.style.width = "100%";
                this._canvas.style.height = "100%";
                this._canvas.style.overflow = "visible";
                this._canvas.style.display = "block";
                this._holder.appendChild(this._canvas);
            }
            View.canvas = this._canvas;
        }

        /**
         * @private
         */

    }, {
        key: "_createRotateImage",
        value: function _createRotateImage() {
            if (P3.utils.isCocoonJS()) return;

            this._rotateImage = document.createElement("div");
            this._rotateImage.id = "rotateImage";
            this._rotateImage.style.position = "absolute";
            this._rotateImage.style.left = 0;
            this._rotateImage.style.top = 0;

            this._rotateImage.style.width = "100%";
            this._rotateImage.style.height = "100%";
            this._rotateImage.style.marginLeft = "auto";
            this._rotateImage.style.marginRight = 0 + "auto";
            this._rotateImage.style.overflow = "visible";
            this._rotateImage.style.display = "none";
            this._rotateImage.style.zIndex = 1000;

            this._rotateImage.style.backgroundImage = this._options.rotateImageUrl ? "url(" + this._options.rotateImageUrl + ")" : "";
            this._rotateImage.style.backgroundColor = this._options.rotateImageColor || 0xFFFFFF;
            this._rotateImage.style.backgroundPosition = "50% 50%";
            this._rotateImage.style.backgroundRepeat = "no-repeat";
            this._rotateImage.style.backgroundSize = "100% auto";

            this._holder.appendChild(this._rotateImage);

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchmove", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchstart", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            this._rotateImage.addEventListener("touchend", function (event) {
                event.preventDefault();
                return false;
            });
        }

        /**
         * @param {number} width
         * @param {number} height
         * @private
         */

    }, {
        key: "_updateDimensions",
        value: function _updateDimensions(width, height) {
            View.width = this._width = Math.round(width);
            View.height = this._height = Math.round(height);
            View.center.x = Math.round(width * 0.5);
            View.center.y = Math.round(height * 0.5);
        }

        /**
         * @private
         */

    }, {
        key: "_disableInteractions",
        value: function _disableInteractions() {
            // prevent dragging the ui
            View.canvas.addEventListener("touchmove", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            View.canvas.addEventListener("touchstart", function (event) {
                event.preventDefault();
                return false;
            });

            // prevent dragging the ui
            View.canvas.addEventListener("touchend", function (event) {
                event.preventDefault();
                return false;
            });

            if (_ismobilejs2.default.android.device) {
                View.canvas.addEventListener("mousedown", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);

                View.canvas.addEventListener("mouseup", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);

                View.canvas.addEventListener("click", function (event) {
                    event.stopPropagation();
                    event.preventDefault();
                    event.stopImmediatePropagation();
                }, false);
            }
        }

        /**
         * @private
         */

    }, {
        key: "_onLoad",
        value: function _onLoad() {
            this._createHolder();
            this._createCanvas();
            this._createRotateImage();
            this._disableInteractions();

            if (P3.utils.isCocoonJS()) {
                this._updateDimensions(this._options.width * (window.innerWidth / this._options.width) / (window.innerHeight / this._options.height), this._options.height);
                this.signals.ready.dispatch(this._canvas);
            } else {
                if (_ismobilejs2.default.android.device) {
                    window.self.addEventListener("orientationchange", this._onOrientationChange.bind(this), false);
                } else {
                    window.self.addEventListener("resize", this._onResize.bind(this), false);
                }
                this.signals.ready.dispatch(this._canvas);

                this.resize();
            }
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onResize",
        value: function _onResize(event) {
            this.resize();
        }

        /**
         * @param {Event} event
         * @private
         */

    }, {
        key: "_onOrientationChange",
        value: function _onOrientationChange(event) {
            window.self.addEventListener("resize", listener, false);

            var that = this;
            function listener() {
                window.self.removeEventListener("resize", listener, false);
                that.resize();
            }
        }

        /**
         * @returns {Element}
         */

    }, {
        key: "holder",
        get: function get() {
            return this._holder;
        }

        /**
         * @returns {Object}
         */

    }, {
        key: "options",
        get: function get() {
            return this._options;
        }

        /**
         * @returns {string}
         */

    }, {
        key: "orientation",
        get: function get() {
            return this._width >= this._height ? "landscape" : "portrait";
        }

        /**
         * @returns {boolean}
         */

    }, {
        key: "isCorrectOrientation",
        get: function get() {
            return _ismobilejs2.default.any ? this.orientation === this._targetOrientation : true;
        }
    }]);

    return View;
}();

/**
 * @type {Element}
 */


exports.default = View;
View.holder = null;

/**
 * @type {Element}
 */
View.canvas = null;

/**
 * @type {number}
 */
View.width = 0;

/**
 * @type {number}
 */
View.height = 0;

/**
 * @type {PIXI.Point}
 */
View.center = new PIXI.Point();

},{"ismobilejs":1}],19:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * Two Pi.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var PI_2 = exports.PI_2 = Math.PI * 2;

/**
 * Conversion factor for converting radians to degrees.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var RAD_TO_DEG = exports.RAD_TO_DEG = 180 / Math.PI;

/**
 * Conversion factor for converting degrees to radians.
 *
 * @static
 * @constant
 * @memberOf P3
 * @type {number}
 */
var DEG_TO_RAD = exports.DEG_TO_RAD = Math.PI / 180;

},{}],20:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _const = require("./const");

Object.keys(_const).forEach(function (key) {
  if (key === "default" || key === "__esModule") return;
  Object.defineProperty(exports, key, {
    enumerable: true,
    get: function get() {
      return _const[key];
    }
  });
});

var _AssetManager = require("./AssetManager");

Object.defineProperty(exports, "AssetManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_AssetManager).default;
  }
});

var _Button = require("./Button");

Object.defineProperty(exports, "Button", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Button).default;
  }
});

var _ButtonStates = require("./ButtonStates");

Object.defineProperty(exports, "ButtonStates", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ButtonStates).default;
  }
});

var _Input = require("./Input");

Object.defineProperty(exports, "Input", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Input).default;
  }
});

var _MovieClip = require("./MovieClip");

Object.defineProperty(exports, "MovieClip", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MovieClip).default;
  }
});

var _MovieClipSequence = require("./MovieClipSequence");

Object.defineProperty(exports, "MovieClipSequence", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MovieClipSequence).default;
  }
});

var _MuteButton = require("./MuteButton");

Object.defineProperty(exports, "MuteButton", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_MuteButton).default;
  }
});

var _Scene = require("./Scene");

Object.defineProperty(exports, "Scene", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Scene).default;
  }
});

var _SceneManager = require("./SceneManager");

Object.defineProperty(exports, "SceneManager", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_SceneManager).default;
  }
});

var _Ticker = require("./Ticker");

Object.defineProperty(exports, "Ticker", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Ticker).default;
  }
});

var _View = require("./View");

Object.defineProperty(exports, "View", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_View).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./AssetManager":8,"./Button":9,"./ButtonStates":10,"./Input":11,"./MovieClip":12,"./MovieClipSequence":13,"./MuteButton":14,"./Scene":15,"./SceneManager":16,"./Ticker":17,"./View":18,"./const":19}],21:[function(require,module,exports){
(function (global){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.utils = exports.tracking = exports.settings = exports.math = exports.Vector2 = exports.Color = undefined;

var _audio = require("./audio");

Object.keys(_audio).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _audio[key];
        }
    });
});

var _camera = require("./camera");

Object.keys(_camera).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _camera[key];
        }
    });
});

var _core = require("./core");

Object.keys(_core).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _core[key];
        }
    });
});

var _transition = require("./transition");

Object.keys(_transition).forEach(function (key) {
    if (key === "default" || key === "__esModule") return;
    Object.defineProperty(exports, key, {
        enumerable: true,
        get: function get() {
            return _transition[key];
        }
    });
});

var _Color = require("./math/Color");

var _Color2 = _interopRequireDefault(_Color);

var _Vector = require("./math/Vector2");

var _Vector2 = _interopRequireDefault(_Vector);

var _math = require("./math");

var math = _interopRequireWildcard(_math);

var _tracking = require("./tracking");

var tracking = _interopRequireWildcard(_tracking);

var _utils = require("./utils");

var utils = _interopRequireWildcard(_utils);

var _settings = require("./settings");

var _settings2 = _interopRequireDefault(_settings);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Color = _Color2.default;
exports.Vector2 = _Vector2.default;
exports.math = math;
exports.settings = _settings2.default;
exports.tracking = tracking;
exports.utils = utils;


global.P3 = exports;

}).call(this,typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {})

},{"./audio":4,"./camera":7,"./core":20,"./math":24,"./math/Color":22,"./math/Vector2":23,"./settings":25,"./tracking":32,"./transition":35,"./utils":39}],22:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.math
 */
var Color = function () {
    /**
     * @param {number|string} [hex=0x0]
     * @param {number} [alpha=0]
     */
    function Color() {
        var hex = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0x0;
        var alpha = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;

        _classCallCheck(this, Color);

        /**
         * @member {number}
         */
        this._r = 0;

        /**
         * @member {number}
         */
        this._g = 0;

        /**
         * @member {number}
         */
        this._b = 0;

        /**
         * @member {number}
         */
        this._a = alpha;

        /**
         * @member {number}
         */
        this._h = 0;

        /**
         * @member {number}
         */
        this._s = 0;

        /**
         * @member {number}
         */
        this._v = 0;

        this.setHex(hex);
    }

    /**
     * @param {number} value
     * @returns {string}
     */


    _createClass(Color, [{
        key: "setHex",


        /**
         * Set the color from a hex formatted string.
         * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
         *
         * @param {number|string} value
         * @returns {Color}
         */
        value: function setHex(value) {
            if (typeof value === "number") {
                value = Color.hexNumberToString(value);
            }

            var shorthandRegex = /^#?([a-f\d])([a-f\d])([a-f\d])$/i;
            var hex = value.replace(shorthandRegex, function (m, r, g, b) {
                return r + r + g + g + b + b;
            });

            var result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
            if (result) {
                this._r = parseInt(result[1], 16) / 255;
                this._g = parseInt(result[2], 16) / 255;
                this._b = parseInt(result[3], 16) / 255;

                this._updateHSV();
            }
            return this;
        }

        /**
         * Set the color from another color.
         *
         * @param {Color} color
         * @returns {Color}
         */

    }, {
        key: "setColor",
        value: function setColor(color) {
            this._r = color.r;
            this._g = color.g;
            this._b = color.b;
            this._a = color.a;
            this._h = color.h;
            this._s = color.s;
            this._v = color.v;
            return this;
        }

        /**
         * Set the color from RGB values.
         *
         * @param {number} r - The red value to set.
         * @param {number} g - The green value to set.
         * @param {number} b - The blue value to set.
         * @returns {Color}
         */

    }, {
        key: "setRGB",
        value: function setRGB(r, g, b) {
            this._r = r;
            this._g = g;
            this._b = b;

            this._updateHSV();
            return this;
        }

        /**
         * Set the color from the RGBA values.
         *
         * @param {number} r - The red value to set.
         * @param {number} g - The green value to set.
         * @param {number} b - The blue value to set.
         * @param {number} a - The alpha value to set.
         * @returns {Color}
         */

    }, {
        key: "setRGBA",
        value: function setRGBA(r, g, b, a) {
            this._a = a;

            this.setRGB(r, g, b);
            return this;
        }

        /**
         * Set the color from the HSV values.
         *
         * @param {number} h - The hue value to set.
         * @param {number} s - The saturation value to set.
         * @param {number} v - The brightness value to set.
         * @returns {Color}
         */

    }, {
        key: "setHSV",
        value: function setHSV(h, s, v) {
            this._h = h;
            this._s = s;
            this._v = v;

            this._updateRGB();
            return this;
        }

        /**
         * Desaturate the color.
         *
         * @param {number} [r] - Desaturation r ratio.
         * @param {number} [g] - Desaturation g ratio.
         * @param {number} [b] - Desaturation b ratio.
         * @returns {Color}
         */

    }, {
        key: "desaturate",
        value: function desaturate() {
            var r = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.59;
            var g = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.30;
            var b = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.11;

            this._r = this._g * r + this._r * g + this._b * b;
            this._g = this._r;
            this._b = this._r;

            this._updateHSV();
            return this;
        }

        /**
         * Invert the color.
         *
         * @returns {Color}
         */

    }, {
        key: "invert",
        value: function invert() {
            this._r = 1 - this._r;
            this._g = 1 - this._g;
            this._b = 1 - this._b;

            this._updateHSV();
            return this;
        }

        /**
         * Blend the current color with the given one.
         *
         * @param {Color} to
         * @param {number} [t=0.5] A number between 0 and 1.
         */

    }, {
        key: "lerp",
        value: function lerp(to) {
            var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.5;

            t = Math.min(1, Math.max(0, t));

            this._r = this._r * (1 - t) + to.r * t;
            this._g = this._g * (1 - t) + to.g * t;
            this._b = this._b * (1 - t) + to.b * t;

            this._updateHSV();
            return this;
        }

        /**
         * Randomize the color's values
         *
         * @returns {Color}
         */

    }, {
        key: "random",
        value: function random() {
            this._r = Math.random();
            this._g = Math.random();
            this._b = Math.random();

            this._updateHSV();
            return this;
        }

        /**
         * Normalize the color's values.
         *
         * @private
         */

    }, {
        key: "_normalize",
        value: function _normalize() {
            this._r = this._r < 0 ? 0 : this._r > 1 ? 1 : this._r;
            this._g = this._g < 0 ? 0 : this._g > 1 ? 1 : this._g;
            this._b = this._b < 0 ? 0 : this._b > 1 ? 1 : this._b;
            this._a = this._a < 0 ? 0 : this._a > 1 ? 1 : this._a;
            this._h = Number((this._h - Math.floor(this._h)).toPrecision(8));
            this._s = this._s < 0 ? 0 : this._s > 1 ? 1 : this._s;
            this._v = this._v < 0 ? 0 : this._v > 1 ? 1 : this._v;
        }

        /**
         * Update the color's RGB values from the HSV ones.
         * http://stackoverflow.com/questions/17242144/javascript-convert-hsb-hsv-color-to-rgb-accurately
         *
         * @private
         */

    }, {
        key: "_updateRGB",
        value: function _updateRGB() {
            this._normalize();

            var i = Math.floor(this._h * 6);
            var f = this._h * 6 - i;
            var p = this._v * (1 - this._s);
            var q = this._v * (1 - f * this._s);
            var t = this._v * (1 - (1 - f) * this._s);

            switch (i % 6) {
                case 0:
                    this._r = this._v;
                    this._g = t;
                    this._b = p;
                    break;

                case 1:
                    this._r = q;
                    this._g = this._v;
                    this._b = p;
                    break;

                case 2:
                    this._r = p;
                    this._g = this._v;
                    this._b = t;
                    break;

                case 3:
                    this._r = p;
                    this._g = q;
                    this._b = this._v;
                    break;

                case 4:
                    this._r = t;
                    this._g = p;
                    this._b = this._v;
                    break;

                case 5:
                    this._r = this._v;
                    this._g = p;
                    this._b = q;
                    break;
            }
        }

        /**
         * Update the color's HSV values from the RGB ones.
         * http://www.deadbeef.com/converting_rgb_to_hsv_in_c/
         *
         * @private
         */

    }, {
        key: "_updateHSV",
        value: function _updateHSV() {
            this._normalize();

            var maxC = Math.max(this._r, this._g, this._b);
            var minC = Math.min(this._r, this._g, this._b);
            var delta = maxC - minC;

            var h = 0;
            var s = 0;
            var v = maxC;

            if (delta == 0) {
                h = 0;
                s = 0;
            } else {
                s = delta / maxC;
                var dR = 60 * (maxC - this._r) / delta + 180;
                var dG = 60 * (maxC - this._g) / delta + 180;
                var dB = 60 * (maxC - this._b) / delta + 180;
                if (this._r == maxC) h = dB - dG;else if (this._g == maxC) h = 120 + dR - dB;else h = 240 + dG - dR;
            }

            if (h < 0) h += 360;
            if (h >= 360) h -= 360;

            this._h = h / 360;
            this._s = s;
            this._v = v;
        }

        /**
         * Return the hex value of the color.
         * http://stackoverflow.com/questions/5623838/rgb-to-hex-and-hex-to-rgb
         *
         * @returns {string}
         */

    }, {
        key: "toHex",
        value: function toHex() {
            return "#" + ((1 << 24) + (Math.round(this._r * 255) << 16) + (Math.round(this._g * 255) << 8) + Math.round(this._b * 255)).toString(16).slice(1);
        }

        /**
         * @returns {number}
         */

    }, {
        key: "toNumber",
        value: function toNumber() {
            return (Math.round(this._r * 255) << 16) + (Math.round(this._g * 255) << 8) + Math.round(this._b * 255);
        }

        /**
         * Return the CSS RGBA value.
         *
         * @returns {string}
         */

    }, {
        key: "toCSS",
        value: function toCSS() {
            return "rgba(" + Math.round(this._r * 255) + "," + Math.round(this._g * 255) + "," + Math.round(this._b * 255) + "," + this._a + ")";
        }

        /**
         * Get the color's red value.
         *
         * @returns {number}
         */

    }, {
        key: "r",
        get: function get() {
            return this._r;
        }

        /**
         * Set the color's red value.
         *
         * @param {number} value - The red value to set.
         */
        ,
        set: function set(value) {
            this._r = value;
            this._updateHSV();
        }

        /**
         * Get the color's green value.
         *
         * @returns {number}
         */

    }, {
        key: "g",
        get: function get() {
            return this._g;
        }

        /**
         * Set the color's green value.
         *
         * @param {number} value - The green value to set.
         */
        ,
        set: function set(value) {
            this._g = value;
            this._updateHSV();
        }

        /**
         * Get the color's blue value.
         *
         * @returns {number}
         */

    }, {
        key: "b",
        get: function get() {
            return this._b;
        }

        /**
         * Set the color's blue value.
         *
         * @param {number} value - The blue value to set.
         */
        ,
        set: function set(value) {
            this._b = value;
            this._updateHSV();
        }

        /**
         * Get the color's alpha value.
         *
         * @returns {number}
         */

    }, {
        key: "a",
        get: function get() {
            return this._a;
        }

        /**
         * Set the color's alpha value.
         *
         * @param {number} value - The alpha value to set.
         */
        ,
        set: function set(value) {
            this._a = value;
        }

        /**
         * Get the color's hue value.
         *
         * @returns {number}
         */

    }, {
        key: "h",
        get: function get() {
            return this._h;
        }

        /**
         * Set the color's hue value.
         *
         * @param {number} value - The hue value to set.
         */
        ,
        set: function set(value) {
            this._h = value;
            this._updateRGB();
        }

        /**
         * Get the color's saturation value.
         *
         * @returns {number}
         */

    }, {
        key: "s",
        get: function get() {
            return this._s;
        }

        /**
         * Set the color's saturation value.
         *
         * @param {number} value - The saturation to set.
         */
        ,
        set: function set(value) {
            this._s = value;
            this._updateRGB();
        }

        /**
         * Get the color's brightness value.
         *
         * @returns {number}
         */

    }, {
        key: "v",
        get: function get() {
            return this._v;
        }

        /**
         * Set the color's brightness value.
         *
         * @param {number} value - The brightness to set.
         */
        ,
        set: function set(value) {
            this._v = value;
            this._updateRGB();
        }

        /**
         * The luminosity of the color.
         * http://stackoverflow.com/questions/596216/formula-to-determine-brightness-of-rgb-color
         *
         * @returns {number}
         */

    }, {
        key: "luminosity",
        get: function get() {
            return 0.299 * this._r + 0.587 * this._g + 0.114 * this._b;
        }
    }], [{
        key: "hexNumberToString",
        value: function hexNumberToString(value) {
            var pad = "#000000";
            var hex = parseInt(value).toString(16);
            return pad.substring(0, pad.length - hex.length) + hex;
        }

        /**
         * @param {Color} a
         * @param {Color} b
         * @param {number} [t=0.5]
         * @returns {Color}
         */

    }, {
        key: "lerp",
        value: function lerp(a, b) {
            var t = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;

            var c = new P3.Color(a.toNumber());
            c.lerp(b, t);
            return c;
        }
    }]);

    return Color;
}();

exports.default = Color;

},{}],23:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.math
 */
var Vector2 = function () {
    /**
     * @param {number} [x=0] - The x axis of the vector.
     * @param {number} [y=0] - The y axis of the vector.
     */
    function Vector2() {
        var x = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
        var y = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

        _classCallCheck(this, Vector2);

        /**
         * @member {number}
         */
        this.x = x;

        /**
         * @member {number}
         */
        this.y = y;
    }

    /**
     * Returns a new vector equal to the sum of the vector plus the given vector.
     *
     * @param {Vector2} v - The vector to add.
     * @returns {Vector2}
     */


    _createClass(Vector2, [{
        key: "add",
        value: function add(v) {
            return new Vector2(this.x + v.x, this.y + v.y);
        }

        /**
         * Returns a new vector equal to the sum of the vector minus the given vector.
         *
         * @param {Vector2} v - The vector to subtract.
         * @returns {Vector2}
         */

    }, {
        key: "subtract",
        value: function subtract(v) {
            return new Vector2(this.x - v.x, this.y - v.y);
        }

        /**
         * Returns a new vector equal to the sum of the vector scaled by the given value.
         *
         * @param {number} s - The amount to scale the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "scale",
        value: function scale(s) {
            return new Vector2(this.x * s, this.y * s);
        }

        /**
         * Increments this vector by the given vector.
         *
         * @param {Vector2} v - The vector to add.
         * @returns {Vector2}
         */

    }, {
        key: "incrementBy",
        value: function incrementBy(v) {
            this.x += v.x;
            this.y += v.y;
            return this;
        }

        /**
         * Decrements this vector by the given vector.
         *
         * @param {Vector2} v - The vector to subtract.
         * @returns {Vector2}
         */

    }, {
        key: "decrementBy",
        value: function decrementBy(v) {
            this.x -= v.x;
            this.y -= v.y;
            return this;
        }

        /**
         * Scale this vector by the given value.
         * @param {number} s - The amount to scale the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "scaleBy",
        value: function scaleBy(s) {
            this.x *= s;
            this.y *= s;
            return this;
        }

        /**
         * Normalize the vector to a length of 1.
         * @returns {Vector2}
         */

    }, {
        key: "normalize",
        value: function normalize() {
            var l = this.length;
            if (l > 0) {
                this.x /= l;
                this.y /= l;
            }
            return this;
        }

        /**
         * Crop the vector to the given length.
         *
         * @param {number} length - The length the vector must exceed.
         * @returns {Vector2}
         */

    }, {
        key: "truncate",
        value: function truncate(length) {
            var l = this.length;
            if (l > length) {
                this.x /= l * length;
                this.y /= l * length;
            }
            return this;
        }

        /**
         * Returns the left hand normal of this vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "normal",
        value: function normal() {
            return new Vector2(this.y, -this.x);
        }

        /**
         * Returns the dot product for this and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "dot",
        value: function dot(v) {
            return this.x * v.x + this.y * v.y;
        }

        /**
         * Returns the dot product for the left hand normal of this vector and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "perp",
        value: function perp(v) {
            return -this.y * v.x + this.x * v.y;
        }

        /**
         * Returns a new vector equal to the projection of this vector along the given axis.
         *
         * @param {Vector2} v - The axis we project this vector along.
         * @returns {Vector2}
         */

    }, {
        key: "project",
        value: function project(v) {
            v = v.clone().normalize();
            return v.scale(this.dot(v));
        }

        /**
         * Returns the angle between this vector and the given vector.
         *
         * @param {Vector2} v - The other vector in the equation.
         * @returns {number}
         */

    }, {
        key: "angleBetween",
        value: function angleBetween(v) {
            return Math.atan2(v.y - this.y, v.x - this.x);
        }

        /**
         * Rotate the vector.
         *
         * @param {number} angle - The angle in radians to rotate the vector by.
         * @returns {Vector2}
         */

    }, {
        key: "rotate",
        value: function rotate(angle) {
            var cos = Math.cos(angle);
            var sin = Math.sin(angle);

            var x = cos * this.x - sin * this.y;
            var y = cos * this.y + sin * this.x;

            this.x = x;
            this.y = y;

            return this;
        }

        /**
         * Rotate the vector around a point.
         *
         * @param {number} x - The x axis to rotate around.
         * @param {number} y - The y axis to rotate around.
         * @param {number} angle - The angle in radians to rotate the Vector2 by.
         * @returns {Vector2}
         */

    }, {
        key: "rotateAround",
        value: function rotateAround(x, y, angle) {
            this.x -= x;
            this.y -= y;

            this.rotate(angle);

            this.x += x;
            this.y += y;

            return this;
        }

        /**
         * Creates a clone of the vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "clone",
        value: function clone() {
            return new Vector2(this.x, this.y);
        }

        /**
         * Copies x and y from the given vector.
         *
         * @param {Vector2} v - The vector to copy.
         */

    }, {
        key: "copy",
        value: function copy(v) {
            this.set(v.x, v.y);
        }

        /**
         * Returns true if the given vector is equal to the given vector.
         *
         * @param {Vector2} v - The vector to compare with.
         * @returns {boolean}
         */

    }, {
        key: "equals",
        value: function equals(v) {
            return v.x === this.x && v.x === this.y;
        }

        /**
         * Sets the vector to a new x and y axis.
         * If the y is omitted, both x and y will be set to x.
         *
         * @param {number} [x=0]
         * @param {number} [y=0]
         */

    }, {
        key: "set",
        value: function set(x, y) {
            this.x = x || 0;
            this.y = y || (y !== 0 ? this.x : 0);
        }

        /**
         * Returns a unit vector.
         *
         * @returns {Vector2}
         */

    }, {
        key: "unit",
        value: function unit() {
            var v = this.clone();
            v.normalize();
            return v;
        }

        /**
         * Return the angle (in radians) of the vector.
         *
         * @returns {number}
         */

    }, {
        key: "angle",
        get: function get() {
            return Math.atan2(this.y, this.x);
        }

        /**
         * Returns the magnitude of the vector.
         *
         * @returns {number}
         */

    }, {
        key: "length",
        get: function get() {
            return Math.sqrt(this.lengthSq);
        }

        /**
         * Returns the magnitude squared of the vector.
         * This is significantly faster than getting the length.
         *
         * @returns {number}
         */

    }, {
        key: "lengthSq",
        get: function get() {
            return this.x * this.x + this.y * this.y;
        }
    }]);

    return Vector2;
}();

exports.default = Vector2;

},{}],24:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Color = require("./Color");

Object.defineProperty(exports, "Color", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Color).default;
    }
});

var _Vector = require("./Vector2");

Object.defineProperty(exports, "Vector2", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_Vector).default;
    }
});
exports.random = random;
exports.randomInt = randomInt;
exports.randomBool = randomBool;
exports.randomSign = randomSign;
exports.roundNum = roundNum;
exports.sign = sign;
exports.clamp = clamp;
exports.lerp = lerp;
exports.fmod = fmod;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Returns a random number within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The maximum value (exclusive).
 * @returns {number}
 */
function random(min, max) {
    return Math.random() * (max - min) + min;
}

/**
 * Returns a random integer within a range.
 *
 * @param {number} min - The minimum value (inclusive).
 * @param {number} max - The minimum value (inclusive).
 * @returns {number}
 */
function randomInt(min, max) {
    return Math.floor(Math.random() * (max - min + 1)) + min;
}

/**
 * Returns a random boolean.
 *
 * @returns {boolean}
 */
function randomBool() {
    return Math.random() < 0.5;
}

/**
 * Return -1 or 1.
 *
 * @returns {number}
 */
function randomSign() {
    return randomInt(0, 1) * 2 - 1;
}

/**
 * Rounds a value to a number of decimal places.
 *
 * @param {number} n - The value to round.
 * @param {number} [decimalPlaces=0] - The number of decimal places to round this number to.
 * @returns {number}
 */
function roundNum(n) {
    var decimalPlaces = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var decimals = Math.pow(10, decimalPlaces);
    return Math.round(Math.floor(n * decimals) / decimals);
}

/**
 * Return the sign of the given number.
 *
 * @param {number} n
 * @deprecated
 */
function sign(n) {
    console.warn("Deprecation Warning: Please use 'Math.sign' instead of 'P3.math.sign'.");
    return Math.sign(n);
}

/**
 * Clamps a value to a range.
 *
 * @param {number} n
 * @param {number} min
 * @param {number} max
 * @returns {number}
 */
function clamp(n, min, max) {
    if (n < min) {
        n = min;
    } else if (n > max) {
        n = max;
    }
    return n;
}

/**
 * Linearly interpolate between two values.
 *
 * @param {number} a
 * @param {number} b
 * @param {number} t
 */
function lerp(a, b, t) {
    return a + (b - a) * t;
}

/**
 * https://gist.github.com/wteuber/6241786
 *
 * @param {number} a
 * @param {number} b
 * @returns {number}
 */
function fmod(a, b) {
    return Number((a - Math.floor(a / b) * b).toPrecision(8));
}

},{"./Color":22,"./Vector2":23}],25:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @namespace P3.settings
 */
exports.default = {
  /**
   * @static
   * @memberOf P3.settings
   * @type {boolean}
   * @default false
   */
  WARN_TEXTURE_DIVISIBLE_BY_2: true,

  /**
   * @static
   * @memberOf P3.settings
   * @type {boolean}
   * @default false
   */
  WARN_TEXTURE_DIVISIBLE_BY_4: false
};

},{}],26:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.tracking
 */
var Tracking = function () {
  /**
   * @param {TrackingModule} module
   */
  function Tracking(module) {
    _classCallCheck(this, Tracking);

    this._module = module;
  }

  /**
   * @param {TrackingData} data
   */


  _createClass(Tracking, [{
    key: "track",
    value: function track(data) {
      this._module.track(data);
      Tracking.DEBUG && console.log("Track -", data);
    }
  }]);

  return Tracking;
}();

/**
 * @type {boolean}
 * @static
 */


exports.default = Tracking;
Tracking.DEBUG = false;

},{}],27:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.tracking
 */
var TrackingData = function TrackingData() {
  _classCallCheck(this, TrackingData);
};

exports.default = TrackingData;

},{}],28:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingData2 = require("./TrackingData");

var _TrackingData3 = _interopRequireDefault(_TrackingData2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @memberOf P3.tracking
 */
var TrackingDataGoogleEvent = function (_TrackingData) {
  _inherits(TrackingDataGoogleEvent, _TrackingData);

  /**
   * @param {string} category
   * @param {string} action
   * @param {string} [label]
   * @param {number} [value]
   * @param
   */
  function TrackingDataGoogleEvent(category, action, label, value) {
    _classCallCheck(this, TrackingDataGoogleEvent);

    var _this = _possibleConstructorReturn(this, (TrackingDataGoogleEvent.__proto__ || Object.getPrototypeOf(TrackingDataGoogleEvent)).call(this));

    _this.category = category;
    _this.action = action;
    _this.label = label;
    _this.value = value;
    return _this;
  }

  return TrackingDataGoogleEvent;
}(_TrackingData3.default);

exports.default = TrackingDataGoogleEvent;

},{"./TrackingData":27}],29:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _TrackingData2 = require("./TrackingData");

var _TrackingData3 = _interopRequireDefault(_TrackingData2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @memberOf P3.tracking
 */
var TrackingDataGooglePageView = function (_TrackingData) {
  _inherits(TrackingDataGooglePageView, _TrackingData);

  /**
   * @param {string} page
   */
  function TrackingDataGooglePageView(page) {
    _classCallCheck(this, TrackingDataGooglePageView);

    var _this = _possibleConstructorReturn(this, (TrackingDataGooglePageView.__proto__ || Object.getPrototypeOf(TrackingDataGooglePageView)).call(this));

    _this.page = page;
    return _this;
  }

  return TrackingDataGooglePageView;
}(_TrackingData3.default);

exports.default = TrackingDataGooglePageView;

},{"./TrackingData":27}],30:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 *  TrackingModule
 *
 *  Created by legman on 23/04/2018.
 *
 */

/**
 * @class
 * @memberOf P3.tracking
 */
var TrackingModule = function () {
    function TrackingModule() {
        _classCallCheck(this, TrackingModule);
    }

    /**
     * @param {TrackingData} data
     */


    _createClass(TrackingModule, [{
        key: "track",
        value: function track(data) {
            // override
        }
    }, {
        key: "isScriptFound",
        value: function isScriptFound() {
            return false;
        }
    }]);

    return TrackingModule;
}();

exports.default = TrackingModule;

},{}],31:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _TrackingDataGoogleEvent = require("./TrackingDataGoogleEvent");

var _TrackingDataGoogleEvent2 = _interopRequireDefault(_TrackingDataGoogleEvent);

var _TrackingDataGooglePageView = require("./TrackingDataGooglePageView");

var _TrackingDataGooglePageView2 = _interopRequireDefault(_TrackingDataGooglePageView);

var _TrackingModule2 = require("./TrackingModule");

var _TrackingModule3 = _interopRequireDefault(_TrackingModule2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @memberOf P3.tracking
 */
var TrackingModuleGoogle = function (_TrackingModule) {
    _inherits(TrackingModuleGoogle, _TrackingModule);

    /**
     * @param {string} code
     */
    function TrackingModuleGoogle(code) {
        _classCallCheck(this, TrackingModuleGoogle);

        var _this = _possibleConstructorReturn(this, (TrackingModuleGoogle.__proto__ || Object.getPrototypeOf(TrackingModuleGoogle)).call(this));

        _this.window = window.top || window;
        if (_this.isScriptFound()) {
            ga("create", code, "auto");
        }
        return _this;
    }

    /**
     * @param {TrackingDataGoogleEvent|TrackingDataGooglePage} data
     */


    _createClass(TrackingModuleGoogle, [{
        key: "track",
        value: function track(data) {
            if (this.isScriptFound()) {
                if (data instanceof _TrackingDataGoogleEvent2.default) {
                    ga("send", "event", data.category, data.action, data.label, data.value);
                } else if (data instanceof _TrackingDataGooglePageView2.default) {
                    ga("send", "pageview", "/" + data.page);
                }
            }
            _get(TrackingModuleGoogle.prototype.__proto__ || Object.getPrototypeOf(TrackingModuleGoogle.prototype), "track", this).call(this, data);
        }
    }, {
        key: "isScriptFound",
        value: function isScriptFound() {
            if (!ga) {
                console.warn("Google Analytics script is not found.");
                return false;
            }
            return true;
        }
    }]);

    return TrackingModuleGoogle;
}(_TrackingModule3.default);

exports.default = TrackingModuleGoogle;

},{"./TrackingDataGoogleEvent":28,"./TrackingDataGooglePageView":29,"./TrackingModule":30}],32:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Tracking = require("./Tracking");

Object.defineProperty(exports, "Tracking", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Tracking).default;
  }
});

var _TrackingData = require("./TrackingData");

Object.defineProperty(exports, "TrackingData", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrackingData).default;
  }
});

var _TrackingDataGoogleEvent = require("./TrackingDataGoogleEvent");

Object.defineProperty(exports, "TrackingDataGoogleEvent", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrackingDataGoogleEvent).default;
  }
});

var _TrackingDataGooglePageView = require("./TrackingDataGooglePageView");

Object.defineProperty(exports, "TrackingDataGooglePageView", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrackingDataGooglePageView).default;
  }
});

var _TrackingModule = require("./TrackingModule");

Object.defineProperty(exports, "TrackingModule", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrackingModule).default;
  }
});

var _TrackingModuleGoogle = require("./TrackingModuleGoogle");

Object.defineProperty(exports, "TrackingModuleGoogle", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_TrackingModuleGoogle).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./Tracking":26,"./TrackingData":27,"./TrackingDataGoogleEvent":28,"./TrackingDataGooglePageView":29,"./TrackingModule":30,"./TrackingModuleGoogle":31}],33:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

var _Transition2 = require("./Transition");

var _Transition3 = _interopRequireDefault(_Transition2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
var FadeTransition = function (_Transition) {
    _inherits(FadeTransition, _Transition);

    /**
     * @param {number} [color]
     * @param {number} [duration]
     */
    function FadeTransition(color, duration) {
        _classCallCheck(this, FadeTransition);

        /**
         * @member {number}
         * @private
         */
        var _this = _possibleConstructorReturn(this, (FadeTransition.__proto__ || Object.getPrototypeOf(FadeTransition)).call(this));

        _this._color = color || 0x0;

        /**
         * @member {number}
         * @private
         */
        _this._duration = duration || 0.8;

        /**
         * @member {PIXI.Graphics}
         * @private
         */
        _this._quad = null;
        return _this;
    }

    _createClass(FadeTransition, [{
        key: "init",
        value: function init() {
            _get(FadeTransition.prototype.__proto__ || Object.getPrototypeOf(FadeTransition.prototype), "init", this).call(this);

            this._quad = new PIXI.Graphics();
            this._quad.visible = false;
            this.addChild(this._quad);

            this.resize();
        }

        /**
         * @param {number} [delay=0]
         */

    }, {
        key: "in",
        value: function _in() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

            this._quad.alpha = 0;
            this._quad.visible = true;
            TweenMax.to(this._quad, this._duration * 0.5, {
                delay: delay,
                alpha: 1,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    this.signals.in.dispatch(this);
                },
                onCompleteScope: this
            });
        }

        /**
         * @param {number} [delay=0.5]
         */

    }, {
        key: "out",
        value: function out() {
            var delay = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0.5;

            TweenMax.to(this._quad, this._duration * 0.5, {
                delay: delay,
                alpha: 0,
                ease: Power2.easeInOut,
                onComplete: function onComplete() {
                    this._quad.visible = false;
                    this.signals.out.dispatch(this);
                },
                onCompleteScope: this
            });
        }
    }, {
        key: "resize",
        value: function resize() {
            this._quad.clear();
            this._quad.beginFill(this._color);
            this._quad.drawRect(0, 0, P3.View.width, P3.View.height);
            this._quad.endFill();
        }

        /**
         * @returns {number}
         */

    }, {
        key: "color",
        get: function get() {
            return this._color;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "duration",
        get: function get() {
            return this._duration;
        }
    }]);

    return FadeTransition;
}(_Transition3.default);

exports.default = FadeTransition;

},{"./Transition":34}],34:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * @class
 * @extends PIXI.Container
 * @memberOf P3.transition
 */
var Transition = function (_PIXI$Container) {
    _inherits(Transition, _PIXI$Container);

    function Transition() {
        _classCallCheck(this, Transition);

        /**
         * @member {Object}
         */
        var _this = _possibleConstructorReturn(this, (Transition.__proto__ || Object.getPrototypeOf(Transition)).call(this));

        _this.signals = {};

        /**
         * @member {signals.Signal}
         */
        _this.signals.in = new signals.Signal();

        /**
         * @member {signals.Signal}
         */
        _this.signals.out = new signals.Signal();

        _this.on("added", _this.init, _this);
        return _this;
    }

    _createClass(Transition, [{
        key: "init",
        value: function init() {
            this.off("added", this.init);

            this.interactive = true;
        }

        /**
         * @param options
         * @param [options.children=false]
         * @param [options.texture=false]
         * @param [options.baseTexture=false]
         */

    }, {
        key: "destroy",
        value: function destroy(options) {
            this.signals.in.dispose();
            this.signals.out.dispose();

            _get(Transition.prototype.__proto__ || Object.getPrototypeOf(Transition.prototype), "destroy", this).call(this, options);
        }

        /**
         */

    }, {
        key: "in",
        value: function _in() {
            this.signals.in.dispatch(this);
        }

        /**
         */

    }, {
        key: "out",
        value: function out() {
            this.signals.out.dispatch(this);
        }

        /**
         */

    }, {
        key: "resize",
        value: function resize() {
            // override
        }
    }]);

    return Transition;
}(PIXI.Container);

exports.default = Transition;

},{}],35:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _FadeTransition = require("./FadeTransition");

Object.defineProperty(exports, "FadeTransition", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_FadeTransition).default;
  }
});

var _Transition = require("./Transition");

Object.defineProperty(exports, "Transition", {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Transition).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

},{"./FadeTransition":33,"./Transition":34}],36:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * Created by noOne on 12/12/2017.
 */
/**
 * Best performing path finding algorithm in cases where node distances are all the same (unweighted graph / grid).
 * Could be adapted to use without a target in which case it will find path to every node, which has a slightly different use case
 * @class
 */
var BreadthFirst = function () {
    function BreadthFirst() {
        _classCallCheck(this, BreadthFirst);

        /**
         * Our graph or grid (the map representation)
         * @type {null}
         * @private
         */
        this._graph = null;

        /**
         * Source node (where does our agent start)
         * @type {null}
         * @private
         */
        this._source = null;

        /**
         * Target node (where is our agent going)
         * @type {null}
         * @private
         */
        this._target = null;

        /**
         * List of nodes currently being explored
         * @type {Array}
         * @private
         */
        this._openList = [];
    }

    _createClass(BreadthFirst, [{
        key: 'init',
        value: function init() {

            if (!this._graph) throw new Error('must set graph before init');
            if (!this._source) throw new Error('must set source before init');

            var startNode = void 0;

            for (var x = 0; x < this._graph.length; x++) {
                for (var y = 0; y < this._graph[x].length; y++) {

                    var vert = this._graph[x][y];

                    vert.neighbours = [];
                    vert.prev = null;

                    vert.x = x;
                    vert.y = y;

                    //--find the nodes neighbours (make sure to override)--//
                    this.findNeighbours(vert);

                    if (BreadthFirst.compareXY({ x: x, y: y }, this._source)) {
                        //if node is source node we can immediately mark as visited
                        vert.visited = true;
                        startNode = vert;
                    }
                }
            }

            //--we want the list to be fifo--//
            this._openList.reverse(); //why reverse an empty list? - todo remove
            this._openList.push(startNode);
        }

        /**
         * Override this function with your own function that finds neighbours appropriately and includes collision however this
         * is defined in your graph representation.
         * @abstract
         * @param vertex {{neighbours: Array, prev: Object}}
         */

    }, {
        key: 'findNeighbours',
        value: function findNeighbours(vertex) {
            throw new Error("abstract functions must be overridden! : BFS.findNeighbours()");

            //minimal example function, could also include collision with something like - if (vertex.blocked) return;
            if (vertex.x > 0) vertex.neighbours.push(this._graph[vertex.x - 1][vertex.y]); //grid sq left
            if (vertex.x < this._graph.length - 1) vertex.neighbours.push(this._graph[vertex.x + 1][vertex.y]); //grid sq right
            if (vertex.y > 0) vertex.neighbours.push(this._graph[vertex.x][vertex.y - 1]); //grid sq above
            if (vertex.y < this._graph[vertex.x].length - 1) vertex.neighbours.push(this._graph[vertex.x][vertex.y + 1]); //grid sq below
        }
    }, {
        key: 'findPath',
        value: function findPath() {

            if (!this._target) throw new Error('must set target before performing BFS');

            var arr = [];
            var endNode = void 0;

            while (this._openList.length > 0) {

                //--get our first vertex--//
                var u = this._openList[this._openList.length - 1];

                //--visit this node (remove from open list and mark as visited)--//
                this._openList.pop();
                u.visited = true;

                //--if it is our target node we are done--//
                if (BreadthFirst.compareXY(u, this._target)) {
                    console.warn("found target");
                    endNode = u;
                    break;
                }

                //--otherwise lets explore the neighbours--//
                for (var i = 0; i < u.neighbours.length; i++) {
                    var v = u.neighbours[i];
                    if (!v.visited) {
                        v.visited = true;
                        v.prev = u;

                        this._openList.unshift(v); //fifo

                        var edge = { start: u, end: v };
                        arr.push(edge);
                    }
                }
            }

            var path = [];

            var node = endNode;
            //--trace back to start node to create the path--//
            var recurse = function recurse() {
                //using a little recursive function to trace the path backwards
                path.push({ x: node.x, y: node.y });
                if (node.prev) {
                    node = node.prev;
                    recurse();
                }
            };
            recurse();

            return path;
        }

        /**
         * Pass in a container to run a simple test
         * @param scene {PIXI.Container}
         */

    }, {
        key: 'test',
        value: function test(scene) {

            var tWid = 25;
            var holder = new PIXI.Container();
            var gridSize = 25;
            var graph = P3.utils.matrix(gridSize, gridSize);

            holder.x = tWid * (gridSize * 0.5);
            scene.addChild(holder);

            for (var x = 0; x < gridSize; x++) {
                for (var y = 0; y < gridSize; y++) {

                    var _sp = new PIXI.Sprite(PIXI.Texture.WHITE);
                    _sp.anchor.set(0.5);
                    holder.addChild(_sp);
                    _sp.x = x * tWid;
                    _sp.y = y * tWid + tWid;

                    _sp.width = tWid - 2;
                    _sp.height = tWid - 2;

                    _sp.tint = 0xD8D8D8;

                    graph[x][y] = { x: x, y: y }; //grid should be stored as int and we will multiply out to get tile pos

                    if (Math.random() < 0.1) {
                        //set blocked tile
                        _sp.tint = 0x3C3CCC;
                        graph[x][y].blocked = true;
                    }
                }
            }

            this.graph = graph;
            this.source = graph[0][0]; //set source to be top left
            this.target = { x: gridSize - 1, y: gridSize - 1 };

            var t0 = performance.now();
            this.init();
            var path = this.findPath();
            var t1 = performance.now();
            console.warn("found paths in : " + (t1 - t0));

            //--create a sprite and put it in top left corner of graph--//
            var sp = new PIXI.Sprite(PIXI.Texture.WHITE);
            sp.tint = 0xff0000;
            holder.addChild(sp);
            sp.anchor.set(0.5);
            sp.position.set(graph[0][0].x, graph[0][0].y);
            sp.width = tWid * 0.5;
            sp.height = tWid * 0.5;

            followPath(sp, tWid, path);

            /**
             * Simple recursive function that tests the path by tweening the sprite along it
             * @param sprite
             * @param tWid
             * @param path
             */
            function followPath(sprite, tWid, path) {
                var node = path[path.length - 1];
                TweenMax.to(sprite, 0.2, {
                    x: node.x * tWid,
                    y: node.y * tWid + tWid,
                    ease: Power0.easeNone,
                    onComplete: function onComplete() {
                        path.pop();
                        if (path.length > 0) followPath(sprite, tWid, path);
                    }
                });
            }
        }

        /**
         * Compares two points
         * @param point1 {PIXI.Point}
         * @param point2 {PIXI.Point}
         * @returns {boolean}
         */

    }, {
        key: 'graph',
        set: function set(value) {
            this._graph = value;
        }
    }, {
        key: 'source',
        set: function set(value) {
            this._source = value;
        }
    }, {
        key: 'target',
        set: function set(value) {
            this._target = value;
        }
    }], [{
        key: 'compareXY',
        value: function compareXY(point1, point2) {
            return Math.round(point1.x) === Math.round(point2.x) && Math.round(point1.y) === Math.round(point2.y);
        }
    }]);

    return BreadthFirst;
}();

exports.default = BreadthFirst;

},{}],37:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.utils
 */
var ObjectPool = function () {
    /**
     * @param {*} t
     * @param {number} size
     * @param {Array} args
     */
    function ObjectPool(t, size, args) {
        _classCallCheck(this, ObjectPool);

        /**
         * @member {*}
         * @protected
         */
        this._t = t;

        /**
         * @type {Array}
         * @private
         */
        this._args = args || [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._free = [];

        /**
         * @member {Array.<*>}
         * @protected
         */
        this._used = [];

        this.expand(Math.max(1, size));
    }

    /**
     */


    _createClass(ObjectPool, [{
        key: "destroy",
        value: function destroy() {
            for (var i = 0; i < this._free.length; ++i) {
                var object = this._free[i];
                object && object.destroy && object.destroy();
            }
            this._free.length = 0;

            for (var _i = 0; _i < this._used.length; ++_i) {
                var _object = this._used[_i];
                _object && _object.destroy && _object.destroy();
            }
            this._used.length = 0;
        }

        /**
         * @param {number} size
         */

    }, {
        key: "expand",
        value: function expand(size) {
            for (var i = 0; i < size; ++i) {
                var object = Object.create(this._t.prototype);
                object.constructor = this._t;
                this._t.apply(object, this._args);
                this._free.push(object);
            }
        }

        /**
         * @returns {*}
         */

    }, {
        key: "create",
        value: function create() {
            var object = this._free.shift();
            if (!object) return null;

            this._used.push(object);
            return object;
        }

        /**
         * @param {*} obj
         * @returns {boolean}
         */

    }, {
        key: "free",
        value: function free(obj) {
            var index = this._used.indexOf(obj);
            if (index !== -1) {
                obj.reset && obj.reset();
                this._free.push(obj);
                this._used.splice(index, 1);
            }
            return index !== -1;
        }

        /**
         * @returns {*}
         */

    }, {
        key: "baseClass",
        get: function get() {
            return this._t;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "size",
        get: function get() {
            return this._free.length + this._used.length;
        }

        /**
         * @returns {number}
         */

    }, {
        key: "available",
        get: function get() {
            return this._free.length;
        }
    }]);

    return ObjectPool;
}();

exports.default = ObjectPool;

},{}],38:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

/**
 * @class
 * @memberOf P3.utils
 */
var TweenList = function () {
    function TweenList() {
        _classCallCheck(this, TweenList);

        this._tweens = [];
    }

    _createClass(TweenList, [{
        key: "destroy",
        value: function destroy() {
            this.killAll();

            this._tweens = null;
        }

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to add to the list.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was added.
         */

    }, {
        key: "add",
        value: function add(tween) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = 0; i < len; ++i) {
                    this.add(arguments[tween]);
                }
            } else {
                if (this._tweens.indexOf(tween) !== -1) return tween;
                this._tweens.push(tween);
            }
            return tween;
        }

        /**
         * @param {...TweenMax|TweenLite|TimelineMax|TimelineLite} tween - The tween(s) to remove from the list.
         * @returns {TweenMax|TweenLite|TimelineMax|TimelineLite} The first tween that was removed.
         */

    }, {
        key: "remove",
        value: function remove(tween) {
            var len = arguments.length;
            if (len > 1) {
                for (var i = len - 1; i >= 0; --i) {
                    this.add(arguments[tween]);
                }
            } else {
                var _i = this._tweens.indexOf(tween);
                if (_i === -1) return;
                this._tweens.splice(_i, 1);
            }
            return tween;
        }
    }, {
        key: "pauseAll",
        value: function pauseAll() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.pause();
            }
        }
    }, {
        key: "resumeAll",
        value: function resumeAll() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.resume();
            }
        }
    }, {
        key: "pauseAll",
        value: function pauseAll() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.pause();
            }
        }
    }, {
        key: "resumeAll",
        value: function resumeAll() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.resume();
            }
        }
    }, {
        key: "killAll",
        value: function killAll() {
            for (var i = 0; i < this._tweens.length; ++i) {
                var tween = this._tweens[i];
                tween.kill();
            }
            this._tweens.length = 0;
        }
    }]);

    return TweenList;
}();

exports.default = TweenList;

},{}],39:[function(require,module,exports){
"use strict";

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _BreadthFirst = require("./BreadthFirst");

Object.defineProperty(exports, "BreadthFirst", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_BreadthFirst).default;
    }
});

var _ObjectPool = require("./ObjectPool");

Object.defineProperty(exports, "ObjectPool", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_ObjectPool).default;
    }
});

var _TweenList = require("./TweenList");

Object.defineProperty(exports, "TweenList", {
    enumerable: true,
    get: function get() {
        return _interopRequireDefault(_TweenList).default;
    }
});
exports.copyObject = copyObject;
exports.copyOwnPropertiesFrom = copyOwnPropertiesFrom;
exports.padNum = padNum;
exports.selectRandom = selectRandom;
exports.shuffleArray = shuffleArray;
exports.isCocoonJS = isCocoonJS;
exports.array = array;
exports.marray = marray;
exports.sprite = sprite;
exports.boundsCheck = boundsCheck;
exports.collide = collide;
exports.collideAABB = collideAABB;
exports.collideSAT = collideSAT;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Creates an identical copy of an object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} original
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
function copyObject(original) {
    var deep = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    var copy = Object.create(Object.getPrototypeOf(original));
    copyOwnPropertiesFrom(copy, original, deep);
    return copy;
}

/**
 * Copies all of an object's properties to the target object.
 * http://speakingjs.com/es5/ch17.html#code_copyOwnPropertiesFrom
 *
 * @param {Object} target
 * @param {Object} source
 * @param {boolean} [deep=true]
 * @returns {Object}
 */
function copyOwnPropertiesFrom(target, source) {
    var deep = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;

    Object.getOwnPropertyNames(source).forEach(function (key) {
        var descriptor = Object.getOwnPropertyDescriptor(source, key);
        Object.defineProperty(target, key, descriptor);
        if (deep && _typeof(descriptor.value) === "object" && descriptor.value !== null) {
            target[key] = P3.utils.copyObject(source[key], deep);
        }
    });
    return target;
}

/**
 * Returns a value converted to a zero padded string.
 *
 * @param {number} n - The value to pad.
 * @param {number} [width=0] - The number of zeros to pad the string with.
 * @returns {string}
 */
function padNum(n) {
    var width = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;

    var num = Math.abs(n);
    var zeros = Math.max(0, width - Math.floor(num).toString().length);
    var zeroStr = Math.pow(10, zeros).toString().substr(1);
    if (num < 0) {
        zeroStr = "-" + zeroStr;
    }
    return zeroStr + num;
}

/**
 * @param {Array} arr
 * @returns {*}
 */
function selectRandom(arr) {
    return arr[Math.floor(Math.random() * arr.length)];
}

/**
 * @param {Array} arr
 * @returns {array}
 */
function shuffleArray(arr) {
    var i = arr.length;
    var t = null;
    var r = -1;

    while (0 !== i) {
        r = Math.floor(Math.random() * i);
        t = arr[--i];
        arr[i] = arr[r];
        arr[r] = t;
    }
    return arr;
}

/**
 * @returns {boolean}
 */
function isCocoonJS() {
    return typeof navigator["isCocoonJS"] !== "undefined";
}

/**
 * Returns an array of pre defined length with optional default values.
 * @deprecated
 * @param {number} length - Array length.
 * @param {*} [defaultValue=null] - Default value.
 * @returns {Array}
 */
function array(length) {
    var defaultValue = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

    var arr = [];
    for (var i = 0; i < length; i++) {
        arr.push(defaultValue);
    }return arr;
}

/**
 * Returns a multi-dimensional array of pre defined size with optional default values.
 * @param {number} rows - Number of rows.
 * @param {number} columns - Number of columns.
 * @param {*} [defaultValue=null] - Default value.
 * @returns {Array<Array>}
 */
function marray(rows, columns) {
    var defaultValue = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;

    var y = [];
    for (var i = 0; i < rows; i++) {
        var x = [];
        for (var j = 0; j < columns; j++) {
            x[j] = defaultValue;
        }y[i] = x;
    }
    return y;
}

/**
 * @param {PIXI.Texture} texture
 * @param {PIXI.Container} [parent]
 * @param {PIXI.Point} [anchor]
 * @returns {PIXI.Sprite}
 */
function sprite(texture, parent, anchor) {
    if (texture instanceof PIXI.Texture === false) {
        console.warn("arg is not of type PIXI.Texture : utils.sprite");
        texture = new PIXI.Graphics().beginFill(0xff0000, 0.5).drawRect(0, 0, 125, 125).endFill().generateTexture();
    }
    anchor = anchor || new PIXI.Point();
    var sprite = new PIXI.Sprite(texture);
    sprite.anchor = anchor;
    parent && parent.addChild(sprite);
    return sprite;
}

/**
 * Checks if first argument is fully within the bounds of the 2nd
 * @param displayObject {PIXI.DisplayObject} - Display object your testing
 * @param boundingObj {PIXI.DisplayObject} - Display object your testing against
 * @param [hitSide] {Object} - Optional param, object will contain which side was hit, or null for no hit
 * @returns {boolean}
 */
function boundsCheck(displayObject, boundingObj, hitSide) {
    if (!displayObject || !boundingObj || !displayObject.getBounds || !boundingObj.getBounds) throw new Error("both args must be PIXI.DisplayObject : utils.boundsCheck");
    var dispObj = displayObject.getBounds();

    var topLeftPoint = {
        x: dispObj.x,
        y: dispObj.y
    };
    var topRightPoint = {
        x: dispObj.x + dispObj.width,
        y: dispObj.y
    };

    var botLeftPoint = {
        x: dispObj.x,
        y: dispObj.y + dispObj.height
    };
    var botRightPoint = {
        x: dispObj.x + dispObj.width,
        y: dispObj.y + dispObj.height
    };

    if (hitSide) {
        //hit side is an object so can return by reference
        if (!boundingObj.containsPoint(topLeftPoint) && !boundingObj.containsPoint(botLeftPoint) && boundingObj.containsPoint(topRightPoint) && boundingObj.containsPoint(botRightPoint)) {
            hitSide.side = "left";
        } else if (!boundingObj.containsPoint(topRightPoint) && !boundingObj.containsPoint(botRightPoint) && boundingObj.containsPoint(topLeftPoint) && boundingObj.containsPoint(botLeftPoint)) {
            hitSide.side = "right";
        } else if (!boundingObj.containsPoint(topLeftPoint) && !boundingObj.containsPoint(topRightPoint) && boundingObj.containsPoint(botLeftPoint) && boundingObj.containsPoint(botRightPoint)) {
            hitSide.side = "top";
        } else if (!boundingObj.containsPoint(botLeftPoint) && !boundingObj.containsPoint(botRightPoint) && boundingObj.containsPoint(topLeftPoint) && boundingObj.containsPoint(topRightPoint)) {
            hitSide.side = "bottom";
        }
    }

    return boundingObj.containsPoint(topLeftPoint) && boundingObj.containsPoint(topRightPoint) && boundingObj.containsPoint(botLeftPoint) && boundingObj.containsPoint(botRightPoint);
}

/**
 * Performs broad phase AABB collision detection, where a collision occurs SAT collision is then performed to ensure a collision actually occurred.
 * Can also handle polygons, although you must maintain a list of points (vertices) for the polygon yourself.
 * @param shape1 {PIXI.Sprite || PIXI.Graphics}
 * @param shape2 {PIXI.Sprite || PIXI.Graphics}
 * @returns {*}
 */
function collide(shape1, shape2) {
    //--broad phase--//
    if (collideAABB(shape1, shape2)) {
        //--narrow phase--//
        var result = collideSAT(shape1, shape2);
        if (result) return result;
    }
    return false;
}

/**
 * Simple axis aligned bounding box collision.
 * @param r1 {PIXI.DisplayObject}
 * @param r2 {PIXI.DisplayObject}
 * @param scale {PIXI.Point}
 * @returns {boolean}
 */
function collideAABB(r1, r2) {
    var scale = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : new PIXI.Point(1, 1);

    r1 = r1.getBounds();
    r2 = r2.getBounds();

    return !(r2.x > r1.x + r1.width * scale.x || r2.x + r2.width * scale.x < r1.x || r2.y > r1.y + r1.height * scale.y || r2.y + r2.height * scale.y < r1.y);
}

/**
 * Collision testing with rotation, also returns overlap if a collision occurs, should be able to use overlap
 * to push the sprite out of whatever it collided with. Can take a normal sprite or graphics with a list
 * of points (the vertices of your polygon as global coordinates, you must maintain this list).
 *
 * Original source - https://gist.github.com/louisstow/807250 - added fixes and adapted to PIXI
 * @param poly1 {PIXI.Sprite}
 * @param poly2 {PIXI.Sprite}
 * @returns {Object|Boolean}
 */
function collideSAT(poly1, poly2) {
    var points1 = poly1.points === undefined ? convertVertsToVectors(poly1.vertexData) : convertVertsToVectors(poly1.points);
    var points2 = poly2.points === undefined ? convertVertsToVectors(poly2.vertexData) : convertVertsToVectors(poly2.points);

    var l = points1.length,
        k = points2.length,
        normal = { x: 0, y: 0 },
        length = void 0,
        min1 = void 0,
        min2 = void 0,
        max1 = void 0,
        max2 = void 0,
        interval = void 0,
        MTV = void 0,
        dot = void 0,
        nextPoint = void 0,
        currentPoint = void 0;

    //loop through the edges of Polygon 1
    for (var i = 0; i < l; i++) {
        nextPoint = points1[i === l - 1 ? 0 : i + 1];
        currentPoint = points1[i];

        //generate the normal for the current edge
        normal.x = -(nextPoint[1] - currentPoint[1]);
        normal.y = nextPoint[0] - currentPoint[0];

        //normalize the vector
        length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
        normal.x /= length;
        normal.y /= length;

        //default min max
        min1 = min2 = -1;
        max1 = max2 = -1;

        //project all vertices from poly1 onto axis
        for (var j = 0; j < l; ++j) {
            dot = points1[j][0] * normal.x + points1[j][1] * normal.y;
            if (dot > max1 || max1 === -1) max1 = dot;
            if (dot < min1 || min1 === -1) min1 = dot;
        }

        //project all vertices from poly2 onto axis
        for (var _j = 0; _j < k; ++_j) {
            dot = points2[_j][0] * normal.x + points2[_j][1] * normal.y;
            if (dot > max2 || max2 === -1) max2 = dot;
            if (dot < min2 || min2 === -1) min2 = dot;
        }

        //calculate the minimum translation vector should be negative
        interval = min1 < min2 ? min2 - max1 : min1 - max2;

        //exit early if positive
        if (interval > 0) {
            return false;
        }
        if (interval > MTV) MTV = interval;
    }

    //loop through the edges of Polygon 1
    for (var _i = 0; _i < k; _i++) {
        nextPoint = points2[_i === k - 1 ? 0 : _i + 1];
        currentPoint = points2[_i];

        //generate the normal for the current edge
        normal.x = -(nextPoint[1] - currentPoint[1]);
        normal.y = nextPoint[0] - currentPoint[0];

        //normalize the vector
        length = Math.sqrt(normal.x * normal.x + normal.y * normal.y);
        normal.x /= length;
        normal.y /= length;

        //default min max
        min1 = min2 = -1;
        max1 = max2 = -1;

        //project all vertices from poly1 onto axis
        for (var _j2 = 0; _j2 < l; ++_j2) {
            dot = points1[_j2][0] * normal.x + points1[_j2][1] * normal.y;
            if (dot > max1 || max1 === -1) max1 = dot;
            if (dot < min1 || min1 === -1) min1 = dot;
        }

        //project all vertices from poly2 onto axis
        for (var _j3 = 0; _j3 < k; ++_j3) {
            dot = points2[_j3][0] * normal.x + points2[_j3][1] * normal.y;
            if (dot > max2 || max2 === -1) max2 = dot;
            if (dot < min2 || min2 === -1) min2 = dot;
        }

        //calculate the minimum translation vector should be negative
        interval = min1 < min2 ? min2 - max1 : min1 - max2;

        //exit early if positive
        if (interval > 0) {
            return false;
        }
        if (interval > MTV) MTV = interval;
    }

    return { overlap: MTV };

    function convertVertsToVectors(verts) {
        var arr = P3.utils.marray(4, 2);

        var count = 0;
        for (var _i2 = 0; _i2 < verts.length; _i2 += 2) {
            arr[count][0] = verts[_i2];
            arr[count][1] = verts[_i2 + 1];
            count++;
        }

        return arr;
    }
}

},{"./BreadthFirst":36,"./ObjectPool":37,"./TweenList":38}]},{},[21])

